export default {
    zh: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI 图像生成器 - 微鲤AI',
        metaDescription: 'Google Nano Banana(Gemini 2.5 Flash Image) 是一款由 Google DeepMind 开发的 AI 图像生成和编辑模型。该模型以其卓越的角色一致性（Character Consistency）而著称，并因此在社交媒体上广受欢迎。您现在可以在 微鲤AI 图像生成器中免费试用 Google Nano Banana 模型。',
        metaKeywords: 'Nano Banana, Google AI, 图像生成, AI 绘画, 人工智能, 图像编辑, 角色一致性',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI 图像生成器',
        generatorSubtitle: 'Google Nano Banana(Gemini 2.5 Flash Image) 是一款由 Google DeepMind 开发的 AI 图像生成和编辑模型。该模型以其卓越的角色一致性（Character Consistency）而著称，并因此在社交媒体上广受欢迎。您现在可以在 微鲤AI 图像生成器中免费试用 Google Nano Banana 模型。',
        
        // Core Features Section
        coreFeaturesTitle: 'Nano Banana 核心功能特性',
        coreFeaturesSubtitle: '探索 Google Nano Banana AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',
        
        // Features
        soatTitle: 'SOAT 图像生成',
        soatDesc: '以无与伦比的风格精度创建细节丰富的图像。Nano Banana 能够生成具有专业级质量的图像，支持多种艺术风格和创意表达。',
        soatAlt: 'SOAT 图像生成示例',
        
        characterConsistencyTitle: '完美的角色一致性',
        characterConsistencyDesc: '在迭代变化中保持角色和场景元素以确保一致性。无论生成多少张图像，角色的外观、特征和风格都保持完美统一。',
        characterConsistencyAlt: '完美的角色一致性示例',
        
        naturalLanguageTitle: '自然语言图像编辑',
        naturalLanguageDesc: '使用纯文本实现高级图像编辑。通过简单的文字描述，您可以精确调整图像的细节、颜色、风格和构图。',
        naturalLanguageAlt: '自然语言图像编辑示例',
        
        multiFusionTitle: '多图像融合',
        multiFusionDesc: '合并多幅图像、插入对象、重新设计场景或组合视觉效果。智能融合技术让您轻松创建复杂的图像合成效果。',
        multiFusionAlt: '多图像融合示例',
        
        ultraFastTitle: '超快速图像处理',
        ultraFastDesc: '几秒钟内生成专业级图像。Nano Banana 的优化算法确保您能够快速获得高质量的图像结果，大大提升创作效率。',
        ultraFastAlt: '超快速图像处理示例',
        
        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        
        step1Title: '选择模型',
        step1Desc: '在 AI 图像工具中选择 Nano Banana 模型',
        
        step2Title: '输入内容',
        step2Desc: '输入提示词或上传参考图像',
        
        step3Title: '生成图像',
        step3Desc: '点击生成按钮，等待并下载您的图像',
        
        // YouTube Videos Section
        youtubeTitle: '关于 Nano Banana AI 图像模型的YouTube 视频',
        
        // X Posts Section
        xPostsTitle: '关于 Nano Banana AI 图像模型的 X 帖子',
        
        // Explore Other Models Section
        exploreTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: '常见问题解答',
        
        faq1Question: '什么是 Google Nano Banana?',
        faq1Answer: 'Google Nano Banana(Gemini 2.5 Flash Image) 是一款强大的 AI 图像生成器，它允许用户通过简单的语言来创建和编辑高质量图像。它的核心优势是能够处理复杂的指令，并确保角色和场景在多次修改中保持一致。',
        
        faq2Question: 'Nano Banana 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Nano Banana 在角色一致性、图像细化、多图像融合和处理速度方面具有显著优势。它能够保持角色在不同场景中的外观一致性，并支持自然语言图像编辑。',
        
        faq3Question: '我可以免费使用 Google Nano Banana 吗？',
        faq3Answer: '是的。您可以通过WeryAI免费使用Nano Banana进行图像生成。只需注册一个账户，我们的免费试用计划就能让您体验这款AI模型的全部功能，快速生成专业级的AI图像。',
        
        faq4Question: 'Nano Banana 支持哪些图像格式?',
        faq4Answer: 'Nano Banana 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',
        
        faq5Question: '我可以使用 Nano Banana 用于商业项目吗?',
        faq5Answer: '是的。Nano Banana 的高精度图像生成和完美的角色一致性使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',
        
        faq6Question: 'Google Nano Banana 支持哪些艺术风格？',
        faq6Answer: '您可以使用 Google Nano Banana 生成任何视觉风格的图像。无论是写实风格、动漫风格、抽象艺术、3D图像，还是奇幻艺术，它都能轻松处理，非常适合艺术家、营销人员和游戏设计师等数字创作者。',
        
        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Google Nano Banana，将您的创意转化为精彩图像',
        ctaButton: 'Try Nano Banana on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    en: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI Image Generator - Free Character-Consistent Images',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) is an AI image generation and editing model developed by Google DeepMind. Known for outstanding character consistency, it has gained popularity on social media. Try Google Nano Banana for free on 微鲤AI image generator!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, image generation, AI art, character consistency, image editing, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI Image Generator',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) is an AI image generation and editing model developed by Google DeepMind. Known for its outstanding character consistency, it has gained popularity on social media. Try Google Nano Banana for free on 微鲤AI image generator now!',
        
        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana',
        coreFeaturesSubtitle: 'Explore the core features of Google Nano Banana AI Image Generator and embark on a revolutionary AI image creation journey',
        
        // Features
        soatTitle: 'SOAT Image Generation',
        soatDesc: 'Create detailed images with unparalleled style precision. Nano Banana generates professional-quality images supporting multiple artistic styles and creative expressions.',
        soatAlt: 'SOAT Image Generation Example',
        
        characterConsistencyTitle: 'Perfect Character Consistency',
        characterConsistencyDesc: 'Maintain character and scene elements for consistency across iterative changes. Character appearance, features, and style remain perfectly unified no matter how many images are generated.',
        characterConsistencyAlt: 'Perfect Character Consistency Example',
        
        naturalLanguageTitle: 'Natural Language Image Editing',
        naturalLanguageDesc: 'Achieve advanced image editing using plain text. With simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',
        naturalLanguageAlt: 'Natural Language Image Editing Example',
        
        multiFusionTitle: 'Multi-Image Fusion',
        multiFusionDesc: 'Merge multiple images, insert objects, redesign scenes, or combine visual effects. Smart fusion technology lets you easily create complex image compositions.',
        multiFusionAlt: 'Multi-Image Fusion Example',
        
        ultraFastTitle: 'Ultra-Fast Image Processing',
        ultraFastDesc: 'Generate professional-grade images in seconds. Nano Banana\'s optimized algorithms ensure you get high-quality image results quickly, greatly improving creative efficiency.',
        ultraFastAlt: 'Ultra-Fast Image Processing Example',
        
        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',
        
        step1Title: 'Select Model',
        step1Desc: 'Choose Nano Banana model in AI image tools',
        
        step2Title: 'Input Content',
        step2Desc: 'Enter prompts or upload reference images',
        
        step3Title: 'Generate Images',
        step3Desc: 'Click generate button, wait and download your images',
        
        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos about Nano Banana AI Image Model',
        
        // X Posts Section
        xPostsTitle: 'X Posts about Nano Banana AI Image Model',
        
        // Explore Other Models Section
        exploreTitle: 'Explore Other AI Image Models on 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'Frequently Asked Questions',
        
        faq1Question: 'What is Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) is a powerful AI image generator that allows users to create and edit high-quality images through simple language. Its core advantage is the ability to handle complex instructions and ensure characters and scenes remain consistent across multiple edits.',
        
        faq2Question: 'What advantages does Nano Banana have over other image generation models?',
        faq2Answer: 'Nano Banana has significant advantages in character consistency, image refinement, multi-image fusion, and processing speed. It maintains character appearance consistency across different scenes and supports natural language image editing.',
        
        faq3Question: 'Can I use Google Nano Banana for free?',
        faq3Answer: 'Yes. You can use Nano Banana for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',
        
        faq4Question: 'What image formats does Nano Banana support?',
        faq4Answer: 'Nano Banana supports various image formats including JPG, PNG, WEBP, and other common formats. Generated images have high quality and rich detail expression.',
        
        faq5Question: 'Can I use Nano Banana for commercial projects?',
        faq5Answer: 'Yes. Nano Banana\'s high-precision image generation and perfect character consistency make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',
        
        faq6Question: 'What artistic styles does Google Nano Banana support?',
        faq6Answer: 'You can use Google Nano Banana to generate images in any visual style. Whether it\'s realistic, anime, abstract art, 3D images, or fantasy art, it can handle them easily, making it perfect for digital creators like artists, marketers, and game designers.',
        
        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Google Nano Banana now and transform your ideas into amazing images',
        ctaButton: 'Try Nano Banana on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // 日语翻译
        metaTitle: 'Google Nano Banana AI画像ジェネレーター - 無料のキャラクター一貫性画像',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) は、Google DeepMindが開発したAI画像生成・編集モデルです。優れたキャラクターの一貫性で知られ、ソーシャルメディアで人気を博しています。WeryAI画像ジェネレーターで無料でお試しください！',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, 画像生成, AIアート, キャラクター一貫性, 画像編集, Google DeepMind',
        
        generatorTitle: 'Google Nano Banana AI画像ジェネレーター',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) は、Google DeepMindが開発したAI画像生成・編集モデルです。優れたキャラクターの一貫性で知られ、ソーシャルメディアで人気を博しています。今すぐWeryAI画像ジェネレーターで無料でお試しください！',
        
        coreFeaturesTitle: 'Nano Bananaの主な機能',
        coreFeaturesSubtitle: 'Google Nano Banana AI画像ジェネレーターの主な機能を探索し、革新的なAI画像作成の旅に出ましょう',
        
        soatTitle: 'SOAT画像生成',
        soatDesc: '比類のないスピードと詳細で高品質な画像を生成',
        soatAlt: 'SOAT画像生成の例',
        
        characterConsistencyTitle: 'キャラクターの一貫性',
        characterConsistencyDesc: '複数の画像にわたって一貫したキャラクターの外観を維持',
        characterConsistencyAlt: 'キャラクター一貫性の例',
        
        creativeControlTitle: 'クリエイティブコントロール',
        creativeControlDesc: 'スタイル、構図、詳細を正確にコントロール',
        creativeControlAlt: 'クリエイティブコントロールの例',
        
        editingCapabilitiesTitle: '編集機能',
        editingCapabilitiesDesc: '高度な画像編集と修正機能',
        editingCapabilitiesAlt: '編集機能の例',
        
        highResolutionTitle: '高解像度出力',
        highResolutionDesc: '卓越した鮮明さと詳細を持つ画像を生成',
        highResolutionAlt: '高解像度出力の例',
        
        howToUseTitle: '使い方',
        howToUseSubtitle: '簡単3ステップで開始',
        
        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールでNano Bananaモデルを選択',
        
        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        
        step3Title: '画像を生成',
        step3Description: '生成ボタンをクリックし、待機して画像をダウンロード',
        
        youtubeTitle: 'Nano BananaについてのYouTube動画',
        
        xPostsTitle: 'Nano BananaについてのX投稿',
        
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Wan AI画像ジェネレーター',
        model2Title: 'FLUX AI画像ジェネレーター',
        model3Title: 'Google Imagen AI画像ジェネレーター',
        
        faqTitle: 'よくある質問',
        
        faq1Question: 'Google Nano Bananaとは何ですか？',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) は、Google DeepMindが開発したAI画像生成・編集モデルです。優れたキャラクターの一貫性で際立ち、ソーシャルメディアプラットフォームで大きな人気を得ています。',
        
        faq2Question: 'Nano Bananaは他の画像生成モデルと比べてどのような利点がありますか？',
        faq2Answer: 'Nano Bananaは、キャラクターの一貫性、画像品質、クリエイティブコントロール、編集機能において大きな利点があります。複数の画像にわたって一貫したキャラクターの外観を維持でき、これはストーリー作成やブランドデザインにとって特に重要です。',
        
        faq3Question: 'Nano Bananaを無料で使用できますか？',
        faq3Answer: 'はい。Nano BananaはWeryAIの無料トライアルを通じて限定的な無料クレジットを提供しています。大量使用の場合はアップグレードが必要です。',
        
        faq4Question: 'Nano Bananaはどのような画像形式をサポートしていますか？',
        faq4Answer: 'Nano BananaはJPG、PNG、WEBPなどの一般的な形式を含む様々な画像形式をサポートしています。生成された画像は高品質で豊富な詳細を特徴としています。',
        
        faq5Question: 'Nano Bananaを商業プロジェクトに使用できますか？',
        faq5Answer: 'はい。Nano Bananaのキャラクター一貫性と高品質画像生成機能は、信頼性の高いAI生成画像を求めるデザイナー、アーティスト、コンテンツクリエーターにとって強力な選択肢となります。',
        
        faq6Question: 'Google Nano Bananaはどのような芸術スタイルをサポートしていますか？',
        faq6Answer: 'Google Nano Bananaを使用して、あらゆる視覚スタイルの画像を生成できます。リアリスティック、アニメ、抽象アート、3D画像、ファンタジーアートなど、簡単に扱うことができ、アーティスト、マーケター、ゲームデザイナーなどのデジタルクリエーターに最適です。',
        
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐGoogle Nano Bananaを体験し、あなたのアイデアを素晴らしい画像に変換',
        ctaButton: 'Try Nano Banana on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
            naturalLanguageTitle: '', // Pending alignment
            naturalLanguageDesc: '', // Pending alignment
            naturalLanguageAlt: '', // Pending alignment
            multiFusionTitle: '', // Pending alignment
            multiFusionDesc: '', // Pending alignment
            multiFusionAlt: '', // Pending alignment
            ultraFastTitle: '', // Pending alignment
            ultraFastDesc: '', // Pending alignment
            ultraFastAlt: '', // Pending alignment
            step1Desc: '', // Pending alignment
            step2Desc: '', // Pending alignment
            step3Desc: '', // Pending alignment
            exploreTitle: '', // Pending alignment
            imagenTitle: '', // Pending alignment
            qwenTitle: '', // Pending alignment
            seedreamTitle: '', // Pending alignment
    },
    ko: {
        // 韩语翻译
        metaTitle: 'Google Nano Banana AI 이미지 생성기 - 무료 캐릭터 일관성 이미지',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image)는 Google DeepMind에서 개발한 AI 이미지 생성 및 편집 모델입니다. 뛰어난 캐릭터 일관성으로 알려져 있으며 소셜 미디어에서 인기를 얻고 있습니다. 微鲤AI 이미지 생성기에서 무료로 체험해보세요!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, 이미지 생성, AI 아트, 캐릭터 일관성, 이미지 편집, Google DeepMind',
        
        generatorTitle: 'Google Nano Banana AI 이미지 생성기',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image)는 Google DeepMind에서 개발한 AI 이미지 생성 및 편집 모델입니다. 뛰어난 캐릭터 일관성으로 알려져 있으며 소셜 미디어에서 인기를 얻고 있습니다. 지금 微鲤AI 이미지 생성기에서 무료로 체험해보세요!',
        
        coreFeaturesTitle: 'Nano Banana의 주요 기능',
        coreFeaturesSubtitle: 'Google Nano Banana AI 이미지 생성기의 주요 기능을 탐색하고 혁신적인 AI 이미지 제작 여정을 시작하세요',
        
        soatTitle: 'SOAT 이미지 생성',
        soatDesc: '비교할 수 없는 속도와 디테일로 고품질 이미지 생성',
        soatAlt: 'SOAT 이미지 생성 예시',
        
        characterConsistencyTitle: '캐릭터 일관성',
        characterConsistencyDesc: '여러 이미지에서 일관된 캐릭터 외관 유지',
        characterConsistencyAlt: '캐릭터 일관성 예시',
        
        creativeControlTitle: '크리에이티브 제어',
        creativeControlDesc: '스타일, 구성, 세부사항에 대한 정확한 제어 제공',
        creativeControlAlt: '크리에이티브 제어 예시',
        
        editingCapabilitiesTitle: '편집 기능',
        editingCapabilitiesDesc: '고급 이미지 편집 및 수정 기능',
        editingCapabilitiesAlt: '편집 기능 예시',
        
        highResolutionTitle: '고해상도 출력',
        highResolutionDesc: '탁월한 선명도와 디테일로 이미지 생성',
        highResolutionAlt: '고해상도 출력 예시',
        
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        
        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 Nano Banana 모델 선택',
        
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        
        step3Title: '이미지 생성',
        step3Description: '생성 버튼 클릭, 대기 후 이미지 다운로드',
        
        youtubeTitle: 'Nano Banana에 대한 YouTube 비디오',
        
        xPostsTitle: 'Nano Banana에 대한 X 게시물',
        
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Wan AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Google Imagen AI 이미지 생성기',
        
        faqTitle: '자주 묻는 질문',
        
        faq1Question: 'Google Nano Banana가 무엇인가요?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image)는 Google DeepMind에서 개발한 AI 이미지 생성 및 편집 모델입니다. 뛰어난 캐릭터 일관성으로 두각을 나타내며 소셜 미디어 플랫폼에서 큰 인기를 얻고 있습니다.',
        
        faq2Question: 'Nano Banana는 다른 이미지 생성 모델에 비해 어떤 장점이 있나요?',
        faq2Answer: 'Nano Banana는 캐릭터 일관성, 이미지 품질, 크리에이티브 제어, 편집 기능에서 큰 장점이 있습니다. 여러 이미지에서 일관된 캐릭터 외관을 유지할 수 있어 스토리 제작과 브랜드 디자인에 특히 중요합니다.',
        
        faq3Question: 'Nano Banana를 무료로 사용할 수 있나요?',
        faq3Answer: '네. Nano Banana는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 광범위한 사용을 위해서는 업그레이드가 필요합니다.',
        
        faq4Question: 'Nano Banana는 어떤 이미지 형식을 지원하나요?',
        faq4Answer: 'Nano Banana는 JPG, PNG, WEBP 등 일반적인 형식을 포함한 다양한 이미지 형식을 지원합니다. 생성된 이미지는 고품질과 풍부한 디테일을 특징으로 합니다.',
        
        faq5Question: 'Nano Banana를 상업 프로젝트에 사용할 수 있나요?',
        faq5Answer: '네. Nano Banana의 캐릭터 일관성과 고품질 이미지 생성 기능은 신뢰할 수 있는 AI 생성 이미지를 찾는 디자이너, 아티스트, 콘텐츠 크리에이터에게 강력한 선택이 됩니다.',
        
        faq6Question: 'Google Nano Banana는 어떤 예술 스타일을 지원하나요?',
        faq6Answer: 'Google Nano Banana를 사용하여 모든 시각적 스타일의 이미지를 생성할 수 있습니다. 사실적, 애니메이션, 추상 예술, 3D 이미지, 판타지 아트 등 쉽게 다룰 수 있어 아티스트, 마케터, 게임 디자이너 같은 디지털 크리에이터에게 완벽합니다.',
        
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Google Nano Banana를 체험하고 당신의 아이디어를 놀라운 이미지로 변환하세요',
        ctaButton: 'Try Nano Banana on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
            naturalLanguageTitle: '', // Pending alignment
            naturalLanguageDesc: '', // Pending alignment
            naturalLanguageAlt: '', // Pending alignment
            multiFusionTitle: '', // Pending alignment
            multiFusionDesc: '', // Pending alignment
            multiFusionAlt: '', // Pending alignment
            ultraFastTitle: '', // Pending alignment
            ultraFastDesc: '', // Pending alignment
            ultraFastAlt: '', // Pending alignment
            step1Desc: '', // Pending alignment
            step2Desc: '', // Pending alignment
            step3Desc: '', // Pending alignment
            exploreTitle: '', // Pending alignment
            imagenTitle: '', // Pending alignment
            qwenTitle: '', // Pending alignment
            seedreamTitle: '', // Pending alignment
    },
    tw: {

        // SEO Meta
        metaTitle: 'Google Nano Banana AI 图像生成器 - 微鲤AI',
        metaDescription: 'Google Nano Banana(Gemini 2.5 Flash Image) 是一款由 Google DeepMind 开发的 AI 图像生成和编辑模型。该模型以其卓越的角色一致性（Character Consistency）而著称，并因此在社交媒体上广受欢迎。您现在可以在 微鲤AI 图像生成器中免费试用 Google Nano Banana 模型。',
        metaKeywords: 'Nano Banana, Google AI, 图像生成, AI 绘画, 人工智能, 图像编辑, 角色一致性',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI 图像生成器',
        generatorSubtitle: 'Google Nano Banana(Gemini 2.5 Flash Image) 是一款由 Google DeepMind 开发的 AI 图像生成和编辑模型。该模型以其卓越的角色一致性（Character Consistency）而著称，并因此在社交媒体上广受欢迎。您现在可以在 微鲤AI 图像生成器中免费试用 Google Nano Banana 模型。',
        
        // Core Features Section
        coreFeaturesTitle: 'Nano Banana 核心功能特性',
        coreFeaturesSubtitle: '探索 Google Nano Banana AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',
        
        // Features
        soatTitle: 'SOAT 图像生成',
        soatDesc: '以无与伦比的风格精度创建细节丰富的图像。Nano Banana 能够生成具有专业级质量的图像，支持多种艺术风格和创意表达。',
        soatAlt: 'SOAT 图像生成示例',
        
        characterConsistencyTitle: '完美的角色一致性',
        characterConsistencyDesc: '在迭代变化中保持角色和场景元素以确保一致性。无论生成多少张图像，角色的外观、特征和风格都保持完美统一。',
        characterConsistencyAlt: '完美的角色一致性示例',
        
        naturalLanguageTitle: '自然语言图像编辑',
        naturalLanguageDesc: '使用纯文本实现高级图像编辑。通过简单的文字描述，您可以精确调整图像的细节、颜色、风格和构图。',
        naturalLanguageAlt: '自然语言图像编辑示例',
        
        multiFusionTitle: '多图像融合',
        multiFusionDesc: '合并多幅图像、插入对象、重新设计场景或组合视觉效果。智能融合技术让您轻松创建复杂的图像合成效果。',
        multiFusionAlt: '多图像融合示例',
        
        ultraFastTitle: '超快速图像处理',
        ultraFastDesc: '几秒钟内生成专业级图像。Nano Banana 的优化算法确保您能够快速获得高质量的图像结果，大大提升创作效率。',
        ultraFastAlt: '超快速图像处理示例',
        
        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        
        step1Title: '选择模型',
        step1Desc: '在 AI 图像工具中选择 Nano Banana 模型',
        
        step2Title: '输入内容',
        step2Desc: '输入提示词或上传参考图像',
        
        step3Title: '生成图像',
        step3Desc: '点击生成按钮，等待并下载您的图像',
        
        // YouTube Videos Section
        youtubeTitle: '关于 Nano Banana AI 图像模型的YouTube 视频',
        
        // X Posts Section
        xPostsTitle: '关于 Nano Banana AI 图像模型的 X 帖子',
        
        // Explore Other Models Section
        exploreTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: '常见问题解答',
        
        faq1Question: '什么是 Google Nano Banana?',
        faq1Answer: 'Google Nano Banana(Gemini 2.5 Flash Image) 是一款强大的 AI 图像生成器，它允许用户通过简单的语言来创建和编辑高质量图像。它的核心优势是能够处理复杂的指令，并确保角色和场景在多次修改中保持一致。',
        
        faq2Question: 'Nano Banana 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Nano Banana 在角色一致性、图像细化、多图像融合和处理速度方面具有显著优势。它能够保持角色在不同场景中的外观一致性，并支持自然语言图像编辑。',
        
        faq3Question: '我可以免费使用 Google Nano Banana 吗？',
        faq3Answer: '是的。您可以通过WeryAI免费使用Nano Banana进行图像生成。只需注册一个账户，我们的免费试用计划就能让您体验这款AI模型的全部功能，快速生成专业级的AI图像。',
        
        faq4Question: 'Nano Banana 支持哪些图像格式?',
        faq4Answer: 'Nano Banana 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',
        
        faq5Question: '我可以使用 Nano Banana 用于商业项目吗?',
        faq5Answer: '是的。Nano Banana 的高精度图像生成和完美的角色一致性使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',
        
        faq6Question: 'Google Nano Banana 支持哪些艺术风格？',
        faq6Answer: '您可以使用 Google Nano Banana 生成任何视觉风格的图像。无论是写实风格、动漫风格、抽象艺术、3D图像，还是奇幻艺术，它都能轻松处理，非常适合艺术家、营销人员和游戏设计师等数字创作者。',
        
        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Google Nano Banana，将您的创意转化为精彩图像',
        ctaButton: 'Try Nano Banana on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    pl: {

        // SEO Meta
        metaTitle: 'Google Nano Banana AI Image Generator - Free Character-Consistent Images',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) is an AI image generation and editing model developed by Google DeepMind. Known for outstanding character consistency, it has gained popularity on social media. Try Google Nano Banana for free on 微鲤AI image generator!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, image generation, AI art, character consistency, image editing, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI Image Generator',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) is an AI image generation and editing model developed by Google DeepMind. Known for its outstanding character consistency, it has gained popularity on social media. Try Google Nano Banana for free on 微鲤AI image generator now!',
        
        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana',
        coreFeaturesSubtitle: 'Explore the core features of Google Nano Banana AI Image Generator and embark on a revolutionary AI image creation journey',
        
        // Features
        soatTitle: 'SOAT Image Generation',
        soatDesc: 'Create detailed images with unparalleled style precision. Nano Banana generates professional-quality images supporting multiple artistic styles and creative expressions.',
        soatAlt: 'SOAT Image Generation Example',
        
        characterConsistencyTitle: 'Perfect Character Consistency',
        characterConsistencyDesc: 'Maintain character and scene elements for consistency across iterative changes. Character appearance, features, and style remain perfectly unified no matter how many images are generated.',
        characterConsistencyAlt: 'Perfect Character Consistency Example',
        
        naturalLanguageTitle: 'Natural Language Image Editing',
        naturalLanguageDesc: 'Achieve advanced image editing using plain text. With simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',
        naturalLanguageAlt: 'Natural Language Image Editing Example',
        
        multiFusionTitle: 'Multi-Image Fusion',
        multiFusionDesc: 'Merge multiple images, insert objects, redesign scenes, or combine visual effects. Smart fusion technology lets you easily create complex image compositions.',
        multiFusionAlt: 'Multi-Image Fusion Example',
        
        ultraFastTitle: 'Ultra-Fast Image Processing',
        ultraFastDesc: 'Generate professional-grade images in seconds. Nano Banana\'s optimized algorithms ensure you get high-quality image results quickly, greatly improving creative efficiency.',
        ultraFastAlt: 'Ultra-Fast Image Processing Example',
        
        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',
        
        step1Title: 'Select Model',
        step1Desc: 'Choose Nano Banana model in AI image tools',
        
        step2Title: 'Input Content',
        step2Desc: 'Enter prompts or upload reference images',
        
        step3Title: 'Generate Images',
        step3Desc: 'Click generate button, wait and download your images',
        
        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos about Nano Banana AI Image Model',
        
        // X Posts Section
        xPostsTitle: 'X Posts about Nano Banana AI Image Model',
        
        // Explore Other Models Section
        exploreTitle: 'Explore Other AI Image Models on 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'Frequently Asked Questions',
        
        faq1Question: 'What is Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) is a powerful AI image generator that allows users to create and edit high-quality images through simple language. Its core advantage is the ability to handle complex instructions and ensure characters and scenes remain consistent across multiple edits.',
        
        faq2Question: 'What advantages does Nano Banana have over other image generation models?',
        faq2Answer: 'Nano Banana has significant advantages in character consistency, image refinement, multi-image fusion, and processing speed. It maintains character appearance consistency across different scenes and supports natural language image editing.',
        
        faq3Question: 'Can I use Google Nano Banana for free?',
        faq3Answer: 'Yes. You can use Nano Banana for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',
        
        faq4Question: 'What image formats does Nano Banana support?',
        faq4Answer: 'Nano Banana supports various image formats including JPG, PNG, WEBP, and other common formats. Generated images have high quality and rich detail expression.',
        
        faq5Question: 'Can I use Nano Banana for commercial projects?',
        faq5Answer: 'Yes. Nano Banana\'s high-precision image generation and perfect character consistency make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',
        
        faq6Question: 'What artistic styles does Google Nano Banana support?',
        faq6Answer: 'You can use Google Nano Banana to generate images in any visual style. Whether it\'s realistic, anime, abstract art, 3D images, or fantasy art, it can handle them easily, making it perfect for digital creators like artists, marketers, and game designers.',
        
        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Google Nano Banana now and transform your ideas into amazing images',
        ctaButton: 'Try Nano Banana on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // SEO Meta
        metaTitle: 'Generador de Imágenes IA Google Nano Banana - Imágenes de Consistencia de Personajes Gratis',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) es un modelo de generación y edición de imágenes IA desarrollado por Google DeepMind. Conocido por su excepcional consistencia de personajes, ha ganado popularidad en las redes sociales. ¡Prueba Google Nano Banana gratis en el generador de imágenes 微鲤AI!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, generación de imágenes, arte IA, consistencia de personajes, edición de imágenes, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Generador de Imágenes IA Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) es un modelo de generación y edición de imágenes IA desarrollado por Google DeepMind. Conocido por su excepcional consistencia de personajes, ha ganado popularidad en las redes sociales. ¡Prueba Google Nano Banana gratis en el generador de imágenes 微鲤AI ahora!',
        
        // Core Features Section
        coreFeaturesTitle: 'Características Principales de Nano Banana',
        coreFeaturesSubtitle: 'Explora las características principales del Generador de Imágenes IA Google Nano Banana y embárcate en un viaje revolucionario de creación de imágenes IA',
        
        // Features
        soatTitle: 'Generación de Imágenes SOAT',
        soatDesc: 'Crea imágenes detalladas con precisión de estilo sin igual. Nano Banana genera imágenes de calidad profesional que soportan múltiples estilos artísticos y expresiones creativas.',
        soatAlt: 'Ejemplo de Generación de Imágenes SOAT',
        
        characterConsistencyTitle: 'Consistencia Perfecta de Personajes',
        characterConsistencyDesc: 'Mantén personajes y elementos de escena para consistencia a través de cambios iterativos. La apariencia, características y estilo del personaje permanecen perfectamente unificados sin importar cuántas imágenes se generen.',
        characterConsistencyAlt: 'Ejemplo de Consistencia Perfecta de Personajes',
        
        naturalLanguageTitle: 'Edición de Imágenes en Lenguaje Natural',
        naturalLanguageDesc: 'Logra edición avanzada de imágenes usando texto simple. Con descripciones de texto simples, puedes ajustar con precisión detalles, colores, estilos y composición de imágenes.',
        naturalLanguageAlt: 'Ejemplo de Edición de Imágenes en Lenguaje Natural',
        
        multiFusionTitle: 'Fusión de Múltiples Imágenes',
        multiFusionDesc: 'Combina múltiples imágenes, inserta objetos, rediseña escenas o combina efectos visuales. La tecnología de fusión inteligente te permite crear fácilmente composiciones de imágenes complejas.',
        multiFusionAlt: 'Ejemplo de Fusión de Múltiples Imágenes',
        
        ultraFastTitle: 'Procesamiento de Imágenes Ultra Rápido',
        ultraFastDesc: 'Genera imágenes de grado profesional en segundos. Los algoritmos optimizados de Nano Banana aseguran que obtengas resultados de imágenes de alta calidad rápidamente, mejorando enormemente la eficiencia creativa.',
        ultraFastAlt: 'Ejemplo de Procesamiento de Imágenes Ultra Rápido',
        
        // How to Use Section
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar a crear',
        
        step1Title: 'Seleccionar Modelo',
        step1Desc: 'Elige el modelo Nano Banana en las herramientas de imagen IA',
        
        step2Title: 'Ingresar Contenido',
        step2Desc: 'Introduce prompts o sube imágenes de referencia',
        
        step3Title: 'Generar Imágenes',
        step3Desc: 'Haz clic en el botón generar, espera y descarga tus imágenes',
        
        // YouTube Videos Section
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Imagen IA Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'Publicaciones de X sobre el Modelo de Imagen IA Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'Explora Otros Modelos de Imagen IA en 微鲤AI',
        imagenTitle: 'Generador de Imágenes IA Google Imagen',
        qwenTitle: 'Generador de Imágenes IA Qwen Image',
        seedreamTitle: 'Generador de Imágenes IA Seedream',
        
        // FAQ Section
        faqTitle: 'Preguntas Frecuentes',
        
        faq1Question: '¿Qué es Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) es un potente generador de imágenes IA que permite a los usuarios crear y editar imágenes de alta calidad a través de lenguaje simple. Su ventaja principal es la capacidad de manejar instrucciones complejas y asegurar que los personajes y escenas permanezcan consistentes a través de múltiples ediciones.',
        
        faq2Question: '¿Qué ventajas tiene Nano Banana sobre otros modelos de generación de imágenes?',
        faq2Answer: 'Nano Banana tiene ventajas significativas en consistencia de personajes, refinamiento de imágenes, fusión de múltiples imágenes y velocidad de procesamiento. Mantiene la apariencia consistente de los personajes a través de diferentes escenas y soporta edición de imágenes en lenguaje natural.',
        
        faq3Question: '¿Puedo usar Google Nano Banana gratis?',
        faq3Answer: 'Sí. Puedes usar Nano Banana para generación de imágenes gratis a través de 微鲤AI. Simplemente registra una cuenta, y nuestro plan de prueba gratuita te permite experimentar todas las capacidades de este modelo IA para generar rápidamente imágenes IA de grado profesional.',
        
        faq4Question: '¿Qué formatos de imagen soporta Nano Banana?',
        faq4Answer: 'Nano Banana soporta varios formatos de imagen incluyendo JPG, PNG, WEBP y otros formatos comunes. Las imágenes generadas tienen alta calidad y rica expresión de detalles.',
        
        faq5Question: '¿Puedo usar Nano Banana para proyectos comerciales?',
        faq5Answer: 'Sí. La generación de imágenes de alta precisión y la consistencia perfecta de personajes de Nano Banana lo convierten en una opción poderosa para diseñadores, artistas y creadores de contenido que buscan imágenes generadas por IA de alta calidad.',
        
        faq6Question: '¿Qué estilos artísticos soporta Google Nano Banana?',
        faq6Answer: 'Puedes usar Google Nano Banana para generar imágenes en cualquier estilo visual. Ya sea realista, anime, arte abstracto, imágenes 3D o arte fantástico, puede manejarlo fácilmente, siendo perfecto para creadores digitales como artistas, marketers y diseñadores de juegos.',
        
        // CTA Section
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Google Nano Banana ahora y transforma tus ideas en imágenes increíbles',
        ctaButton: 'Prueba Nano Banana en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        // SEO Meta
        metaTitle: 'Générateur d\'Images IA Google Nano Banana - Images à Cohérence de Personnages Gratuites',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) est un modèle de génération et d\'édition d\'images IA développé par Google DeepMind. Connu pour son exceptionnelle cohérence des personnages, il a gagné en popularité sur les réseaux sociaux. Essayez Google Nano Banana gratuitement sur le générateur d\'images 微鲤AI !',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, génération d\'images, art IA, cohérence des personnages, édition d\'images, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Générateur d\'Images IA Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) est un modèle de génération et d\'édition d\'images IA développé par Google DeepMind. Connu pour son exceptionnelle cohérence des personnages, il a gagné en popularité sur les réseaux sociaux. Essayez Google Nano Banana gratuitement sur le générateur d\'images 微鲤AI maintenant !',
        
        // Core Features Section
        coreFeaturesTitle: 'Fonctionnalités Principales de Nano Banana',
        coreFeaturesSubtitle: 'Explorez les fonctionnalités principales du Générateur d\'Images IA Google Nano Banana et lancez-vous dans un voyage révolutionnaire de création d\'images IA',
        
        // Features
        soatTitle: 'Génération d\'Images SOAT',
        soatDesc: 'Créez des images détaillées avec une précision de style inégalée. Nano Banana génère des images de qualité professionnelle supportant plusieurs styles artistiques et expressions créatives.',
        soatAlt: 'Exemple de Génération d\'Images SOAT',
        
        characterConsistencyTitle: 'Cohérence Parfaite des Personnages',
        characterConsistencyDesc: 'Maintenez les personnages et les éléments de scène pour la cohérence à travers les changements itératifs. L\'apparence, les caractéristiques et le style des personnages restent parfaitement unifiés peu importe combien d\'images sont générées.',
        characterConsistencyAlt: 'Exemple de Cohérence Parfaite des Personnages',
        
        naturalLanguageTitle: 'Édition d\'Images en Langage Naturel',
        naturalLanguageDesc: 'Réalisez une édition d\'images avancée en utilisant du texte simple. Avec de simples descriptions textuelles, vous pouvez ajuster avec précision les détails, couleurs, styles et composition des images.',
        naturalLanguageAlt: 'Exemple d\'Édition d\'Images en Langage Naturel',
        
        multiFusionTitle: 'Fusion Multi-Images',
        multiFusionDesc: 'Fusionnez plusieurs images, insérez des objets, redesignez des scènes ou combinez des effets visuels. La technologie de fusion intelligente vous permet de créer facilement des compositions d\'images complexes.',
        multiFusionAlt: 'Exemple de Fusion Multi-Images',
        
        ultraFastTitle: 'Traitement d\'Images Ultra Rapide',
        ultraFastDesc: 'Générez des images de qualité professionnelle en quelques secondes. Les algorithmes optimisés de Nano Banana garantissent que vous obtenez rapidement des résultats d\'images de haute qualité, améliorant considérablement l\'efficacité créative.',
        ultraFastAlt: 'Exemple de Traitement d\'Images Ultra Rapide',
        
        // How to Use Section
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer à créer',
        
        step1Title: 'Sélectionner le Modèle',
        step1Desc: 'Choisissez le modèle Nano Banana dans les outils d\'image IA',
        
        step2Title: 'Entrer le Contenu',
        step2Desc: 'Saisissez des prompts ou téléchargez des images de référence',
        
        step3Title: 'Générer des Images',
        step3Desc: 'Cliquez sur le bouton générer, attendez et téléchargez vos images',
        
        // YouTube Videos Section
        youtubeTitle: 'Vidéos YouTube sur le Modèle d\'Image IA Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'Publications X sur le Modèle d\'Image IA Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'Explorez d\'Autres Modèles d\'Image IA sur 微鲤AI',
        imagenTitle: 'Générateur d\'Images IA Google Imagen',
        qwenTitle: 'Générateur d\'Images IA Qwen Image',
        seedreamTitle: 'Générateur d\'Images IA Seedream',
        
        // FAQ Section
        faqTitle: 'Questions Fréquemment Posées',
        
        faq1Question: 'Qu\'est-ce que Google Nano Banana ?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) est un puissant générateur d\'images IA qui permet aux utilisateurs de créer et d\'éditer des images de haute qualité via un langage simple. Son principal avantage est la capacité de gérer des instructions complexes et d\'assurer que les personnages et scènes restent cohérents à travers plusieurs modifications.',
        
        faq2Question: 'Quels avantages Nano Banana a-t-il par rapport aux autres modèles de génération d\'images ?',
        faq2Answer: 'Nano Banana a des avantages significatifs en cohérence des personnages, raffinement d\'images, fusion multi-images et vitesse de traitement. Il maintient l\'apparence cohérente des personnages à travers différentes scènes et supporte l\'édition d\'images en langage naturel.',
        
        faq3Question: 'Puis-je utiliser Google Nano Banana gratuitement ?',
        faq3Answer: 'Oui. Vous pouvez utiliser Nano Banana pour la génération d\'images gratuitement via 微鲤AI. Inscrivez simplement un compte, et notre plan d\'essai gratuit vous permet de découvrir toutes les capacités de ce modèle IA pour générer rapidement des images IA de qualité professionnelle.',
        
        faq4Question: 'Quels formats d\'image Nano Banana supporte-t-il ?',
        faq4Answer: 'Nano Banana supporte divers formats d\'image dont JPG, PNG, WEBP et autres formats courants. Les images générées présentent une haute qualité et une riche expression de détails.',
        
        faq5Question: 'Puis-je utiliser Nano Banana pour des projets commerciaux ?',
        faq5Answer: 'Oui. La génération d\'images haute précision et la cohérence parfaite des personnages de Nano Banana en font un choix puissant pour les designers, artistes et créateurs de contenu recherchant des images générées par IA de haute qualité.',
        
        faq6Question: 'Quels styles artistiques Google Nano Banana supporte-t-il ?',
        faq6Answer: 'Vous pouvez utiliser Google Nano Banana pour générer des images dans n\'importe quel style visuel. Qu\'il s\'agisse de réalisme, d\'anime, d\'art abstrait, d\'images 3D ou d\'art fantastique, il peut les gérer facilement, ce qui le rend parfait pour les créateurs numériques comme les artistes, les marketeurs et les game designers.',
        
        // CTA Section
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Google Nano Banana maintenant et transformez vos idées en images incroyables',
        ctaButton: 'Essayez Nano Banana sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        // SEO Meta
        metaTitle: 'Google Nano Banana KI-Bildgenerator - Kostenlose Charakterkonsistente Bilder',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) ist ein KI-Bildgenerierungs- und Bearbeitungsmodell, entwickelt von Google DeepMind. Bekannt für herausragende Charakterkonsistenz, hat es in sozialen Medien an Beliebtheit gewonnen. Testen Sie Google Nano Banana kostenlos im 微鲤AI Bildgenerator!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, Bildgenerierung, KI-Kunst, Charakterkonsistenz, Bildbearbeitung, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana KI-Bildgenerator',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) ist ein KI-Bildgenerierungs- und Bearbeitungsmodell, entwickelt von Google DeepMind. Bekannt für seine herausragende Charakterkonsistenz, hat es in sozialen Medien an Beliebtheit gewonnen. Testen Sie Google Nano Banana jetzt kostenlos im 微鲤AI Bildgenerator!',
        
        // Core Features Section
        coreFeaturesTitle: 'Kernfunktionen von Nano Banana',
        coreFeaturesSubtitle: 'Erkunden Sie die Kernfunktionen des Google Nano Banana KI-Bildgenerators und begeben Sie sich auf eine revolutionäre KI-Bilderstellungsreise',
        
        // Features
        soatTitle: 'SOAT-Bildgenerierung',
        soatDesc: 'Erstellen Sie detaillierte Bilder mit unvergleichlicher Stilpräzision. Nano Banana generiert professionelle Bilder, die mehrere künstlerische Stile und kreative Ausdrucksformen unterstützen.',
        soatAlt: 'Beispiel für SOAT-Bildgenerierung',
        
        characterConsistencyTitle: 'Perfekte Charakterkonsistenz',
        characterConsistencyDesc: 'Behalten Sie Charaktere und Szenenelemente für Konsistenz über iterative Änderungen bei. Charakteraussehen, Merkmale und Stil bleiben perfekt einheitlich, egal wie viele Bilder generiert werden.',
        characterConsistencyAlt: 'Beispiel für Perfekte Charakterkonsistenz',
        
        naturalLanguageTitle: 'Natürlichsprachige Bildbearbeitung',
        naturalLanguageDesc: 'Erreichen Sie erweiterte Bildbearbeitung mit einfachem Text. Mit einfachen Textbeschreibungen können Sie Bilddetails, Farben, Stile und Komposition präzise anpassen.',
        naturalLanguageAlt: 'Beispiel für Natürlichsprachige Bildbearbeitung',
        
        multiFusionTitle: 'Multi-Bild-Fusion',
        multiFusionDesc: 'Verschmelzen Sie mehrere Bilder, fügen Sie Objekte ein, gestalten Sie Szenen neu oder kombinieren Sie visuelle Effekte. Intelligente Fusionstechnologie ermöglicht es Ihnen, komplexe Bildkompositionen einfach zu erstellen.',
        multiFusionAlt: 'Beispiel für Multi-Bild-Fusion',
        
        ultraFastTitle: 'Ultraschnelle Bildverarbeitung',
        ultraFastDesc: 'Generieren Sie professionelle Bilder in Sekunden. Nano Bananas optimierte Algorithmen stellen sicher, dass Sie schnell hochwertige Bildergebnisse erhalten und die kreative Effizienz erheblich steigern.',
        ultraFastAlt: 'Beispiel für Ultraschnelle Bildverarbeitung',
        
        // How to Use Section
        howToUseTitle: 'Wie Man Verwendet',
        howToUseSubtitle: 'Drei einfache Schritte zum Erstellen',
        
        step1Title: 'Modell Auswählen',
        step1Desc: 'Wählen Sie das Nano Banana Modell in den KI-Bildwerkzeugen',
        
        step2Title: 'Inhalt Eingeben',
        step2Desc: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
        
        step3Title: 'Bilder Generieren',
        step3Desc: 'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihre Bilder herunter',
        
        // YouTube Videos Section
        youtubeTitle: 'YouTube-Videos über das Nano Banana KI-Bildmodell',
        
        // X Posts Section
        xPostsTitle: 'X-Beiträge über das Nano Banana KI-Bildmodell',
        
        // Explore Other Models Section
        exploreTitle: 'Erkunden Sie Andere KI-Bildmodelle auf 微鲤AI',
        imagenTitle: 'Google Imagen KI-Bildgenerator',
        qwenTitle: 'Qwen Image KI-Bildgenerator',
        seedreamTitle: 'Seedream KI-Bildgenerator',
        
        // FAQ Section
        faqTitle: 'Häufig Gestellte Fragen',
        
        faq1Question: 'Was ist Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) ist ein leistungsstarker KI-Bildgenerator, der es Benutzern ermöglicht, hochwertige Bilder durch einfache Sprache zu erstellen und zu bearbeiten. Sein Hauptvorteil ist die Fähigkeit, komplexe Anweisungen zu verarbeiten und sicherzustellen, dass Charaktere und Szenen über mehrere Bearbeitungen hinweg konsistent bleiben.',
        
        faq2Question: 'Welche Vorteile hat Nano Banana gegenüber anderen Bildgenerierungsmodellen?',
        faq2Answer: 'Nano Banana hat erhebliche Vorteile in Charakterkonsistenz, Bildverfeinerung, Multi-Bild-Fusion und Verarbeitungsgeschwindigkeit. Es hält das Charakteraussehen über verschiedene Szenen hinweg konsistent und unterstützt natürlichsprachige Bildbearbeitung.',
        
        faq3Question: 'Kann ich Google Nano Banana kostenlos verwenden?',
        faq3Answer: 'Ja. Sie können Nano Banana für kostenlose Bildgenerierung über 微鲤AI verwenden. Registrieren Sie einfach ein Konto, und unser kostenloser Testplan ermöglicht es Ihnen, alle Fähigkeiten dieses KI-Modells zu erleben, um schnell professionelle KI-Bilder zu generieren.',
        
        faq4Question: 'Welche Bildformate unterstützt Nano Banana?',
        faq4Answer: 'Nano Banana unterstützt verschiedene Bildformate einschließlich JPG, PNG, WEBP und andere gängige Formate. Generierte Bilder haben hohe Qualität und reichen Detailausdruck.',
        
        faq5Question: 'Kann ich Nano Banana für kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. Nano Bananas hochpräzise Bildgenerierung und perfekte Charakterkonsistenz machen es zu einer leistungsstarken Wahl für Designer, Künstler und Content-Ersteller, die hochwertige KI-generierte Bilder suchen.',
        
        faq6Question: 'Welche künstlerischen Stile unterstützt Google Nano Banana?',
        faq6Answer: 'Sie können Google Nano Banana verwenden, um Bilder in jedem visuellen Stil zu generieren. Ob realistisch, Anime, abstrakte Kunst, 3D-Bilder oder Fantasy-Kunst, es kann sie alle problemlos handhaben und ist perfekt für digitale Kreative wie Künstler, Marketer und Spieledesigner.',
        
        // CTA Section
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Google Nano Banana jetzt und verwandeln Sie Ihre Ideen in erstaunliche Bilder',
        ctaButton: 'Testen Sie Nano Banana auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // SEO Meta
        metaTitle: 'Генератор изображений Google Nano Banana AI - Бесплатные изображения с последовательностью персонажей',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) - это модель генерации и редактирования изображений ИИ, разработанная Google DeepMind. Известная своей исключительной последовательностью персонажей, она приобрела популярность в социальных сетях. Попробуйте Google Nano Banana бесплатно на генераторе изображений 微鲤AI!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, генерация изображений, AI-арт, последовательность персонажей, редактирование изображений, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Генератор изображений Google Nano Banana AI',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) - это модель генерации и редактирования изображений ИИ, разработанная Google DeepMind. Известная своей исключительной последовательностью персонажей, она приобрела популярность в социальных сетях. Попробуйте Google Nano Banana бесплатно на генераторе изображений 微鲤AI прямо сейчас!',
        
        // Core Features Section
        coreFeaturesTitle: 'Основные функции Nano Banana',
        coreFeaturesSubtitle: 'Изучите основные функции генератора изображений Google Nano Banana AI и отправьтесь в революционное путешествие по созданию изображений AI',
        
        // Features
        soatTitle: 'Генерация изображений SOAT',
        soatDesc: 'Создавайте детализированные изображения с беспрецедентной точностью стиля. Nano Banana генерирует изображения профессионального качества, поддерживающие множество художественных стилей и творческих выражений.',
        soatAlt: 'Пример генерации изображений SOAT',
        
        characterConsistencyTitle: 'Идеальная последовательность персонажей',
        characterConsistencyDesc: 'Сохраняйте персонажей и элементы сцены для последовательности через итеративные изменения. Внешний вид, черты и стиль персонажа остаются идеально единообразными независимо от количества созданных изображений.',
        characterConsistencyAlt: 'Пример идеальной последовательности персонажей',
        
        naturalLanguageTitle: 'Редактирование изображений на естественном языке',
        naturalLanguageDesc: 'Достигайте продвинутого редактирования изображений с помощью простого текста. С помощью простых текстовых описаний вы можете точно настраивать детали, цвета, стили и композицию изображений.',
        naturalLanguageAlt: 'Пример редактирования изображений на естественном языке',
        
        multiFusionTitle: 'Слияние нескольких изображений',
        multiFusionDesc: 'Объединяйте несколько изображений, вставляйте объекты, переделывайте сцены или комбинируйте визуальные эффекты. Технология умного слияния позволяет легко создавать сложные композиции изображений.',
        multiFusionAlt: 'Пример слияния нескольких изображений',
        
        ultraFastTitle: 'Сверхбыстрая обработка изображений',
        ultraFastDesc: 'Генерируйте профессиональные изображения за секунды. Оптимизированные алгоритмы Nano Banana обеспечивают быстрое получение высококачественных результатов изображений, значительно повышая творческую эффективность.',
        ultraFastAlt: 'Пример сверхбыстрой обработки изображений',
        
        // How to Use Section
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага для начала создания',
        
        step1Title: 'Выберите модель',
        step1Desc: 'Выберите модель Nano Banana в инструментах AI-изображений',
        
        step2Title: 'Введите содержимое',
        step2Desc: 'Введите промпты или загрузите референсные изображения',
        
        step3Title: 'Сгенерируйте изображения',
        step3Desc: 'Нажмите кнопку генерации, дождитесь и скачайте изображения',
        
        // YouTube Videos Section
        youtubeTitle: 'Видео на YouTube о модели изображений AI Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'Посты в X о модели изображений AI Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'Исследуйте другие модели AI-изображений на 微鲤AI',
        imagenTitle: 'Генератор изображений Google Imagen AI',
        qwenTitle: 'Генератор изображений Qwen Image AI',
        seedreamTitle: 'Генератор изображений Seedream AI',
        
        // FAQ Section
        faqTitle: 'Часто задаваемые вопросы',
        
        faq1Question: 'Что такое Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) - это мощный генератор изображений AI, который позволяет пользователям создавать и редактировать высококачественные изображения с помощью простого языка. Его основное преимущество - способность обрабатывать сложные инструкции и обеспечивать последовательность персонажей и сцен через множественные правки.',
        
        faq2Question: 'Какие преимущества имеет Nano Banana перед другими моделями генерации изображений?',
        faq2Answer: 'Nano Banana имеет значительные преимущества в последовательности персонажей, доработке изображений, слиянии нескольких изображений и скорости обработки. Он поддерживает последовательный внешний вид персонажей в разных сценах и поддерживает редактирование изображений на естественном языке.',
        
        faq3Question: 'Могу ли я использовать Google Nano Banana бесплатно?',
        faq3Answer: 'Да. Вы можете использовать Nano Banana для бесплатной генерации изображений через 微鲤AI. Просто зарегистрируйте аккаунт, и наш бесплатный пробный план позволит вам испытать все возможности этой модели AI для быстрой генерации профессиональных AI-изображений.',
        
        faq4Question: 'Какие форматы изображений поддерживает Nano Banana?',
        faq4Answer: 'Nano Banana поддерживает различные форматы изображений, включая JPG, PNG, WEBP и другие распространенные форматы. Созданные изображения имеют высокое качество и богатое выражение деталей.',
        
        faq5Question: 'Могу ли я использовать Nano Banana для коммерческих проектов?',
        faq5Answer: 'Да. Высокоточная генерация изображений и идеальная последовательность персонажей Nano Banana делают его мощным выбором для дизайнеров, художников и создателей контента, ищущих высококачественные AI-изображения.',
        
        faq6Question: 'Какие художественные стили поддерживает Google Nano Banana?',
        faq6Answer: 'Вы можете использовать Google Nano Banana для генерации изображений в любом визуальном стиле. Будь то реалистичный, аниме, абстрактное искусство, 3D-изображения или фэнтези-арт, он легко справляется со всем, что делает его идеальным для цифровых творцов, таких как художники, маркетологи и игровые дизайнеры.',
        
        // CTA Section
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Испытайте Google Nano Banana сейчас и превратите свои идеи в потрясающие изображения',
        ctaButton: 'Попробуйте Nano Banana на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // SEO Meta
        metaTitle: 'Gerador de Imagens IA Google Nano Banana - Imagens de Consistência de Personagem Grátis',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) é um modelo de geração e edição de imagens IA desenvolvido pelo Google DeepMind. Conhecido por sua excepcional consistência de personagens, ganhou popularidade nas redes sociais. Experimente Google Nano Banana gratuitamente no gerador de imagens 微鲤AI!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, geração de imagens, arte IA, consistência de personagens, edição de imagens, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Gerador de Imagens IA Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) é um modelo de geração e edição de imagens IA desenvolvido pelo Google DeepMind. Conhecido por sua excepcional consistência de personagens, ganhou popularidade nas redes sociais. Experimente Google Nano Banana gratuitamente no gerador de imagens 微鲤AI agora!',
        
        // Core Features Section
        coreFeaturesTitle: 'Recursos Principais do Nano Banana',
        coreFeaturesSubtitle: 'Explore os recursos principais do Gerador de Imagens IA Google Nano Banana e embarque em uma jornada revolucionária de criação de imagens IA',
        
        // Features
        soatTitle: 'Geração de Imagens SOAT',
        soatDesc: 'Crie imagens detalhadas com precisão de estilo incomparável. Nano Banana gera imagens de qualidade profissional que suportam múltiplos estilos artísticos e expressões criativas.',
        soatAlt: 'Exemplo de Geração de Imagens SOAT',
        
        characterConsistencyTitle: 'Consistência Perfeita de Personagens',
        characterConsistencyDesc: 'Mantenha personagens e elementos de cena para consistência através de mudanças iterativas. A aparência, características e estilo dos personagens permanecem perfeitamente unificados independentemente de quantas imagens sejam geradas.',
        characterConsistencyAlt: 'Exemplo de Consistência Perfeita de Personagens',
        
        naturalLanguageTitle: 'Edição de Imagens em Linguagem Natural',
        naturalLanguageDesc: 'Realize edição avançada de imagens usando texto simples. Com descrições de texto simples, você pode ajustar com precisão detalhes, cores, estilos e composição de imagens.',
        naturalLanguageAlt: 'Exemplo de Edição de Imagens em Linguagem Natural',
        
        multiFusionTitle: 'Fusão de Múltiplas Imagens',
        multiFusionDesc: 'Combine múltiplas imagens, insira objetos, redesenhe cenas ou combine efeitos visuais. A tecnologia de fusão inteligente permite que você crie facilmente composições de imagens complexas.',
        multiFusionAlt: 'Exemplo de Fusão de Múltiplas Imagens',
        
        ultraFastTitle: 'Processamento de Imagens Ultra Rápido',
        ultraFastDesc: 'Gere imagens de nível profissional em segundos. Os algoritmos otimizados do Nano Banana garantem que você obtenha resultados de imagens de alta qualidade rapidamente, melhorando enormemente a eficiência criativa.',
        ultraFastAlt: 'Exemplo de Processamento de Imagens Ultra Rápido',
        
        // How to Use Section
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar a criar',
        
        step1Title: 'Selecionar Modelo',
        step1Desc: 'Escolha o modelo Nano Banana nas ferramentas de imagem IA',
        
        step2Title: 'Inserir Conteúdo',
        step2Desc: 'Digite prompts ou carregue imagens de referência',
        
        step3Title: 'Gerar Imagens',
        step3Desc: 'Clique no botão gerar, aguarde e baixe suas imagens',
        
        // YouTube Videos Section
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Imagem IA Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'Posts do X sobre o Modelo de Imagem IA Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'Explore Outros Modelos de Imagem IA no 微鲤AI',
        imagenTitle: 'Gerador de Imagens IA Google Imagen',
        qwenTitle: 'Gerador de Imagens IA Qwen Image',
        seedreamTitle: 'Gerador de Imagens IA Seedream',
        
        // FAQ Section
        faqTitle: 'Perguntas Frequentes',
        
        faq1Question: 'O que é Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) é um poderoso gerador de imagens IA que permite aos usuários criar e editar imagens de alta qualidade através de linguagem simples. Sua principal vantagem é a capacidade de lidar com instruções complexas e garantir que personagens e cenas permaneçam consistentes através de múltiplas edições.',
        
        faq2Question: 'Quais vantagens o Nano Banana tem sobre outros modelos de geração de imagens?',
        faq2Answer: 'Nano Banana tem vantagens significativas em consistência de personagens, refinamento de imagens, fusão de múltiplas imagens e velocidade de processamento. Ele mantém a aparência consistente dos personagens através de diferentes cenas e suporta edição de imagens em linguagem natural.',
        
        faq3Question: 'Posso usar o Google Nano Banana gratuitamente?',
        faq3Answer: 'Sim. Você pode usar Nano Banana para geração de imagens gratuita através do 微鲤AI. Basta registrar uma conta, e nosso plano de teste gratuito permite que você experimente todas as capacidades deste modelo IA para gerar rapidamente imagens IA de nível profissional.',
        
        faq4Question: 'Quais formatos de imagem o Nano Banana suporta?',
        faq4Answer: 'Nano Banana suporta vários formatos de imagem, incluindo JPG, PNG, WEBP e outros formatos comuns. As imagens geradas têm alta qualidade e rica expressão de detalhes.',
        
        faq5Question: 'Posso usar o Nano Banana para projetos comerciais?',
        faq5Answer: 'Sim. A geração de imagens de alta precisão e a consistência perfeita de personagens do Nano Banana o tornam uma escolha poderosa para designers, artistas e criadores de conteúdo que buscam imagens geradas por IA de alta qualidade.',
        
        faq6Question: 'Quais estilos artísticos o Google Nano Banana suporta?',
        faq6Answer: 'Você pode usar o Google Nano Banana para gerar imagens em qualquer estilo visual. Seja realista, anime, arte abstrata, imagens 3D ou arte fantástica, ele pode lidar com tudo facilmente, sendo perfeito para criadores digitais como artistas, profissionais de marketing e designers de jogos.',
        
        // CTA Section
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Google Nano Banana agora e transforme suas ideias em imagens incríveis',
        ctaButton: 'Experimente o Nano Banana no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // SEO Meta
        metaTitle: 'Generatore di Immagini IA Google Nano Banana - Immagini a Coerenza di Personaggi Gratuite',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) è un modello di generazione e modifica di immagini IA sviluppato da Google DeepMind. Noto per l\'eccezionale coerenza dei personaggi, ha guadagnato popolarità sui social media. Prova Google Nano Banana gratuitamente sul generatore di immagini 微鲤AI!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, generazione di immagini, arte IA, coerenza dei personaggi, modifica di immagini, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Generatore di Immagini IA Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) è un modello di generazione e modifica di immagini IA sviluppato da Google DeepMind. Noto per la sua eccezionale coerenza dei personaggi, ha guadagnato popolarità sui social media. Prova Google Nano Banana gratuitamente sul generatore di immagini 微鲤AI ora!',
        
        // Core Features Section
        coreFeaturesTitle: 'Caratteristiche Principali di Nano Banana',
        coreFeaturesSubtitle: 'Esplora le caratteristiche principali del Generatore di Immagini IA Google Nano Banana e intraprendi un viaggio rivoluzionario nella creazione di immagini IA',
        
        // Features
        soatTitle: 'Generazione di Immagini SOAT',
        soatDesc: 'Crea immagini dettagliate con precisione di stile senza pari. Nano Banana genera immagini di qualità professionale che supportano molteplici stili artistici ed espressioni creative.',
        soatAlt: 'Esempio di Generazione di Immagini SOAT',
        
        characterConsistencyTitle: 'Coerenza Perfetta dei Personaggi',
        characterConsistencyDesc: 'Mantieni personaggi ed elementi di scena per la coerenza attraverso cambiamenti iterativi. L\'aspetto, le caratteristiche e lo stile dei personaggi rimangono perfettamente unificati indipendentemente da quante immagini vengono generate.',
        characterConsistencyAlt: 'Esempio di Coerenza Perfetta dei Personaggi',
        
        naturalLanguageTitle: 'Modifica di Immagini in Linguaggio Naturale',
        naturalLanguageDesc: 'Ottieni una modifica avanzata di immagini usando testo semplice. Con semplici descrizioni testuali, puoi regolare con precisione dettagli, colori, stili e composizione delle immagini.',
        naturalLanguageAlt: 'Esempio di Modifica di Immagini in Linguaggio Naturale',
        
        multiFusionTitle: 'Fusione Multi-Immagine',
        multiFusionDesc: 'Unisci più immagini, inserisci oggetti, ridisegna scene o combina effetti visivi. La tecnologia di fusione intelligente ti consente di creare facilmente composizioni di immagini complesse.',
        multiFusionAlt: 'Esempio di Fusione Multi-Immagine',
        
        ultraFastTitle: 'Elaborazione Immagini Ultra Veloce',
        ultraFastDesc: 'Genera immagini di livello professionale in pochi secondi. Gli algoritmi ottimizzati di Nano Banana assicurano che tu ottenga rapidamente risultati di immagini di alta qualità, migliorando notevolmente l\'efficienza creativa.',
        ultraFastAlt: 'Esempio di Elaborazione Immagini Ultra Veloce',
        
        // How to Use Section
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare a creare',
        
        step1Title: 'Seleziona Modello',
        step1Desc: 'Scegli il modello Nano Banana negli strumenti di immagini IA',
        
        step2Title: 'Inserisci Contenuto',
        step2Desc: 'Inserisci prompt o carica immagini di riferimento',
        
        step3Title: 'Genera Immagini',
        step3Desc: 'Clicca sul pulsante genera, attendi e scarica le tue immagini',
        
        // YouTube Videos Section
        youtubeTitle: 'Video di YouTube sul Modello di Immagine IA Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'Post di X sul Modello di Immagine IA Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'Esplora Altri Modelli di Immagine IA su 微鲤AI',
        imagenTitle: 'Generatore di Immagini IA Google Imagen',
        qwenTitle: 'Generatore di Immagini IA Qwen Image',
        seedreamTitle: 'Generatore di Immagini IA Seedream',
        
        // FAQ Section
        faqTitle: 'Domande Frequenti',
        
        faq1Question: 'Cos\'è Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) è un potente generatore di immagini IA che consente agli utenti di creare e modificare immagini di alta qualità attraverso un linguaggio semplice. Il suo principale vantaggio è la capacità di gestire istruzioni complesse e garantire che i personaggi e le scene rimangano coerenti attraverso più modifiche.',
        
        faq2Question: 'Quali vantaggi ha Nano Banana rispetto ad altri modelli di generazione di immagini?',
        faq2Answer: 'Nano Banana ha vantaggi significativi in coerenza dei personaggi, raffinamento delle immagini, fusione multi-immagine e velocità di elaborazione. Mantiene l\'aspetto coerente dei personaggi attraverso diverse scene e supporta l\'editing di immagini in linguaggio naturale.',
        
        faq3Question: 'Posso usare Google Nano Banana gratuitamente?',
        faq3Answer: 'Sim. Você pode usar Nano Banana para geração de imagens gratuita através do 微鲤AI. Basta registrar uma conta, e nosso plano de teste gratuito permite que você experimente todas as capacidades deste modelo IA para gerar rapidamente imagens IA de nível profissional.',
        
        faq4Question: 'Quais formatos de imagem o Nano Banana suporta?',
        faq4Answer: 'Nano Banana suporta vários formatos de imagem, incluindo JPG, PNG, WEBP e outros formatos comuns. As imagens geradas têm alta qualidade e rica expressão de detalhes.',
        
        faq5Question: 'Posso usar o Nano Banana para projetos comerciais?',
        faq5Answer: 'Sim. A geração de imagens de alta precisão e a consistência perfeita de personagens do Nano Banana o tornam uma escolha poderosa para designers, artistas e criadores de conteúdo que buscam imagens geradas por IA de alta qualidade.',
        
        faq6Question: 'Quais estilos artísticos o Google Nano Banana suporta?',
        faq6Answer: 'Você pode usar o Google Nano Banana para gerar imagens em qualquer estilo visual. Seja realista, anime, arte abstrata, imagens 3D ou arte fantástica, ele pode lidar com tudo facilmente, sendo perfeito para criadores digitais como artistas, profissionais de marketing e designers de jogos.',
        
        // CTA Section
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Google Nano Banana agora e transforme suas ideias em imagens incríveis',
        ctaButton: 'Experimente o Nano Banana no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    ar: {
        // SEO Meta
        metaTitle: 'مولد الصور بالذكاء الاصطناعي Google Nano Banana - صور مجانية بتناسق الشخصيات',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) هو نموذج إنشاء وتحرير الصور بالذكاء الاصطناعي الذي طورته Google DeepMind. معروف بتناسق الشخصيات الاستثنائي، وقد اكتسب شعبية على وسائل التواصل الاجتماعي. جرب Google Nano Banana مجانًا على مولد الصور 微鲤AI!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, توليد الصور, فن الذكاء الاصطناعي, تناسق الشخصيات, تحرير الصور, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'مولد الصور بالذكاء الاصطناعي Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) هو نموذج إنشاء وتحرير الصور بالذكاء الاصطناعي الذي طورته Google DeepMind. معروف بتناسق الشخصيات الاستثنائي، وقد اكتسب شعبية على وسائل التواصل الاجتماعي. جرب Google Nano Banana مجانًا على مولد الصور 微鲤AI الآن!',
        
        // Core Features Section
        coreFeaturesTitle: 'الميزات الأساسية لـ Nano Banana',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد الصور بالذكاء الاصطناعي Google Nano Banana وابدأ رحلة ثورية لإنشاء صور بالذكاء الاصطناعي',
        
        // Features
        soatTitle: 'توليد صور SOAT',
        soatDesc: 'أنشئ صورًا مفصلة بدقة أسلوب لا مثيل لها. ينشئ Nano Banana صورًا بجودة احترافية تدعم أنماطًا فنية متعددة وتعبيرات إبداعية.',
        soatAlt: 'مثال على توليد صور SOAT',
        
        characterConsistencyTitle: 'تناسق مثالي للشخصيات',
        characterConsistencyDesc: 'حافظ على الشخصيات وعناصر المشهد للحصول على التناسق عبر التغييرات المتكررة. يظل مظهر الشخصية وميزاتها وأسلوبها موحدًا تمامًا بغض النظر عن عدد الصور المُنشأة.',
        characterConsistencyAlt: 'مثال على التناسق المثالي للشخصيات',
        
        naturalLanguageTitle: 'تحرير الصور بلغة طبيعية',
        naturalLanguageDesc: 'حقق تحرير صور متقدم باستخدام نص بسيط. باستخدام أوصاف نصية بسيطة، يمكنك ضبط تفاصيل الصورة والألوان والأنماط والتكوين بدقة.',
        naturalLanguageAlt: 'مثال على تحرير الصور بلغة طبيعية',
        
        multiFusionTitle: 'دمج صور متعددة',
        multiFusionDesc: 'ادمج صورًا متعددة، أدرج كائنات، أعد تصميم المشاهد أو ادمج التأثيرات البصرية. تتيح لك تقنية الدمج الذكي إنشاء تركيبات صور معقدة بسهولة.',
        multiFusionAlt: 'مثال على دمج صور متعددة',
        
        ultraFastTitle: 'معالجة صور فائقة السرعة',
        ultraFastDesc: 'أنشئ صورًا باحترافية في ثوانٍ. تضمن خوارزميات Nano Banana المُحسَّنة حصولك على نتائج صور عالية الجودة بسرعة، مما يحسن الكفاءة الإبداعية بشكل كبير.',
        ultraFastAlt: 'مثال على معالجة صور فائقة السرعة',
        
        // How to Use Section
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة لبدء الإنشاء',
        
        step1Title: 'اختر النموذج',
        step1Desc: 'اختر نموذج Nano Banana في أدوات الصور بالذكاء الاصطناعي',
        
        step2Title: 'أدخل المحتوى',
        step2Desc: 'أدخل المطالبات أو قم بتحميل صور مرجعية',
        
        step3Title: 'أنشئ الصور',
        step3Desc: 'انقر فوق زر الإنشاء، انتظر وقم بتنزيل صورك',
        
        // YouTube Videos Section
        youtubeTitle: 'فيديوهات YouTube حول نموذج الصور بالذكاء الاصطناعي Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'منشورات X حول نموذج الصور بالذكاء الاصطناعي Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'استكشف نماذج الصور بالذكاء الاصطناعي الأخرى على 微鲤AI',
        imagenTitle: 'مولد الصور بالذكاء الاصطناعي Google Imagen',
        qwenTitle: 'مولد الصور بالذكاء الاصطناعي Qwen Image',
        seedreamTitle: 'مولد الصور بالذكاء الاصطناعي Seedream',
        
        // FAQ Section
        faqTitle: 'الأسئلة الشائعة',
        
        faq1Question: 'ما هو Google Nano Banana؟',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) هو مولد صور ذكاء اصطناعي قوي يسمح للمستخدمين بإنشاء وتحرير صور عالية الجودة من خلال لغة بسيطة. ميزته الأساسية هي القدرة على التعامل مع التعليمات المعقدة وضمان بقاء الشخصيات والمشاهد متسقة عبر تعديلات متعددة.',
        
        faq2Question: 'ما المزايا التي يتمتع بها Nano Banana مقارنة بنماذج توليد الصور الأخرى؟',
        faq2Answer: 'يتمتع Nano Banana بمزايا كبيرة في تناسق الشخصيات وتحسين الصور ودمج الصور المتعددة وسرعة المعالجة. يحافظ على مظهر الشخصيات المتسق عبر مشاهد مختلفة ويدعم تحرير الصور بلغة طبيعية.',
        
        faq3Question: 'هل يمكنني استخدام Google Nano Banana مجانًا؟',
        faq3Answer: 'نعم. يمكنك استخدام Nano Banana لتوليد الصور مجانًا من خلال 微鲤AI. ما عليك سوى تسجيل حساب، وتتيح لك خطة التجربة المجانية الخاصة بنا تجربة جميع قدرات نموذج الذكاء الاصطناعي هذا لتوليد صور ذكاء اصطناعي احترافية بسرعة.',
        
        faq4Question: 'ما تنسيقات الصور التي يدعمها Nano Banana؟',
        faq4Answer: 'يدعم Nano Banana تنسيقات صور مختلفة بما في ذلك JPG و PNG و WEBP وتنسيقات شائعة أخرى. تتميز الصور المُنشأة بجودة عالية وتعبير غني بالتفاصيل.',
        
        faq5Question: 'هل يمكنني استخدام Nano Banana للمشاريع التجارية؟',
        faq5Answer: 'نعم. تجعل توليد الصور عالي الدقة والتناسق المثالي للشخصيات من Nano Banana خيارًا قويًا للمصممين والفنانين ومنشئي المحتوى الذين يبحثون عن صور عالية الجودة مُنشأة بالذكاء الاصطناعي.',
        
        faq6Question: 'ما الأنماط الفنية التي يدعمها Google Nano Banana؟',
        faq6Answer: 'يمكنك استخدام Google Nano Banana لتوليد صور بأي نمط بصري. سواء كان واقعيًا أو أنيمي أو فنًا تجريديًا أو صورًا ثلاثية الأبعاد أو فنًا خياليًا، يمكنه التعامل معها بسهولة، مما يجعله مثاليًا للمبدعين الرقميين مثل الفنانين والمسوقين ومصممي الألعاب.',
        
        // CTA Section
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Google Nano Banana الآن وحوّل أفكارك إلى صور مذهلة',
        ctaButton: 'جرب Nano Banana على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: {
        // SEO Meta
        metaTitle: 'Google Nano Banana เครื่องมือสร้างภาพ AI - ภาพที่คงความสม่ำเสมอตัวละครฟรี',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) คือโมเดลสร้างและแก้ไขภาพ AI จาก Google DeepMind โดดเด่นด้านความสม่ำเสมอของตัวละคร จึงได้รับความนิยมบนโซเชียล ลองใช้ Google Nano Banana ฟรีบนเครื่องมือสร้างภาพ 微鲤AI!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, การสร้างภาพ, ศิลปะ AI, ความสม่ำเสมอของตัวละคร, การแก้ไขภาพ, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'เครื่องมือสร้างภาพ AI Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) คือโมเดลสร้างและแก้ไขภาพ AI จาก Google DeepMind ที่โดดเด่นเรื่องความสม่ำเสมอของตัวละครและได้รับความนิยมบนโซเชียล ลองใช้ฟรีบน 微鲤AI image generator ได้เลย!',
        
        // Core Features Section
        coreFeaturesTitle: 'คุณสมบัติหลักของ Nano Banana',
        coreFeaturesSubtitle: 'สำรวจคุณสมบัติหลักของ Google Nano Banana AI Image Generator และเริ่มต้นการสร้างภาพด้วย AI แบบใหม่',
        
        // Features
        soatTitle: 'การสร้างภาพระดับ SOAT',
        soatDesc: 'สร้างภาพที่ละเอียดและแม่นยำด้านสไตล์อย่างเหนือชั้น Nano Banana สร้างภาพคุณภาพระดับมืออาชีพ รองรับหลายสไตล์และการแสดงออกเชิงสร้างสรรค์',
        soatAlt: 'ตัวอย่างการสร้างภาพระดับ SOAT',
        
        characterConsistencyTitle: 'ความสม่ำเสมอของตัวละครที่สมบูรณ์แบบ',
        characterConsistencyDesc: 'รักษาองค์ประกอบของตัวละครและฉากให้สอดคล้องกันตลอดการแก้ไขซ้ำ ไม่ว่าจะสร้างกี่ภาพ รูปลักษณ์ คุณลักษณะ และสไตล์ยังคงเหมือนเดิม',
        characterConsistencyAlt: 'ตัวอย่างความสม่ำเสมอของตัวละคร',
        
        naturalLanguageTitle: 'การแก้ไขภาพด้วยภาษาธรรมชาติ',
        naturalLanguageDesc: 'แก้ไขภาพขั้นสูงด้วยข้อความธรรมดา เพียงอธิบายด้วยคำ คุณสามารถปรับรายละเอียด สี สไตล์ และองค์ประกอบได้อย่างแม่นยำ',
        naturalLanguageAlt: 'ตัวอย่างการแก้ไขภาพด้วยภาษาธรรมชาติ',
        
        multiFusionTitle: 'การผสานหลายภาพ',
        multiFusionDesc: 'รวมหลายภาพ แทรกวัตถุ ออกแบบฉากใหม่ หรือผสานเอฟเฟกต์ภาพ เทคโนโลยีการผสานอัจฉริยะช่วยให้สร้างองค์ประกอบที่ซับซ้อนได้ง่าย',
        multiFusionAlt: 'ตัวอย่างการผสานหลายภาพ',
        
        ultraFastTitle: 'การประมวลผลภาพที่รวดเร็วเป็นพิเศษ',
        ultraFastDesc: 'สร้างภาพระดับมืออาชีพได้ในไม่กี่วินาที อัลกอริทึมที่ปรับแต่งของ Nano Banana ทำให้ได้ผลลัพธ์คุณภาพสูงอย่างรวดเร็ว เพิ่มประสิทธิภาพการสร้างสรรค์อย่างมาก',
        ultraFastAlt: 'ตัวอย่างการประมวลผลภาพที่รวดเร็วเป็นพิเศษ',
        
        // How to Use Section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'สามขั้นตอนง่ายๆ เพื่อเริ่มสร้าง',
        
        step1Title: 'เลือกโมเดล',
        step1Desc: 'เลือกโมเดล Nano Banana ในเครื่องมือ AI image',
        
        step2Title: 'กรอกเนื้อหา',
        step2Desc: 'ป้อนพรอมต์หรืออัปโหลดภาพอ้างอิง',
        
        step3Title: 'สร้างภาพ',
        step3Desc: 'กดปุ่มสร้าง รอและดาวน์โหลดภาพของคุณ',
        
        // YouTube Videos Section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลภาพ AI Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'โพสต์ X เกี่ยวกับโมเดลภาพ AI Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'สำรวจโมเดลภาพ AI อื่นๆ บน 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'คำถามที่พบบ่อย',
        
        faq1Question: 'Google Nano Banana คืออะไร?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) คือเครื่องมือสร้างภาพ AI ที่ทรงพลัง ช่วยให้ผู้ใช้สร้างและแก้ไขภาพคุณภาพสูงด้วยภาษาอย่างง่าย จุดเด่นคือจัดการคำสั่งที่ซับซ้อนได้ และคงความสม่ำเสมอของตัวละครและฉากในการแก้ไขหลายครั้ง',
        
        faq2Question: 'Nano Banana มีข้อดีเหนือกว่าโมเดลอื่นอย่างไร?',
        faq2Answer: 'Nano Banana โดดเด่นด้านความสม่ำเสมอของตัวละคร การปรับแต่งภาพ การผสานหลายภาพ และความเร็วในการประมวลผล สามารถรักษารูปลักษณ์ของตัวละครข้ามฉากต่างๆ และรองรับการแก้ไขภาพด้วยภาษาธรรมชาติ',
        
        faq3Question: 'สามารถใช้ Google Nano Banana ฟรีได้ไหม?',
        faq3Answer: 'ได้ คุณสามารถใช้ Nano Banana สร้างภาพฟรีผ่าน 微鲤AI เพียงสมัครบัญชี แผนทดลองฟรีจะให้คุณลองใช้ความสามารถเต็มรูปแบบของโมเดลนี้เพื่อสร้างภาพ AI ระดับมืออาชีพได้อย่างรวดเร็ว',
        
        faq4Question: 'Nano Banana รองรับไฟล์ภาพรูปแบบใดบ้าง?',
        faq4Answer: 'Nano Banana รองรับรูปแบบภาพต่างๆ เช่น JPG, PNG, WEBP และรูปแบบยอดนิยมอื่นๆ ภาพที่สร้างมีคุณภาพสูงและรายละเอียดครบถ้วน',
        
        faq5Question: 'ใช้ Nano Banana กับงานเชิงพาณิชย์ได้ไหม?',
        faq5Answer: 'ได้ Nano Banana ให้ความแม่นยำสูงและความสม่ำเสมอของตัวละครอย่างยอดเยี่ยม จึงเหมาะสำหรับนักออกแบบ ศิลปิน และครีเอเตอร์ที่ต้องการภาพ AI คุณภาพสูง',
        
        faq6Question: 'Google Nano Banana รองรับสไตล์ศิลปะแบบใดบ้าง?',
        faq6Answer: 'คุณสามารถใช้ Google Nano Banana สร้างภาพได้ทุกสไตล์ ไม่ว่าจะเป็นสมจริง อนิเมะ นามธรรม ภาพ 3D หรือแฟนตาซี ก็จัดการได้ง่าย เหมาะสำหรับครีเอเตอร์ดิจิทัลอย่างศิลปิน นักการตลาด และนักออกแบบเกม',
        
        // CTA Section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription: 'ลองใช้ Google Nano Banana ตอนนี้ แล้วเปลี่ยนไอเดียของคุณให้เป็นภาพที่น่าทึ่ง',
        ctaButton: 'ลอง Nano Banana บน 微鲤AI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        },
    da: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI-billedgenerator - Gratis billeder med figurkonsistens',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) er en AI-model til billedgenerering og -redigering udviklet af Google DeepMind. Den er kendt for fremragende figurkonsistens og er blevet populær på sociale medier. Prøv Google Nano Banana gratis på 微鲤AI-billedgeneratoren!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, billedgenerering, AI-kunst, figurkonsistens, billedredigering, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI-billedgenerator',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) er en AI-model til billedgenerering og -redigering udviklet af Google DeepMind. Kendt for sin fremragende figurkonsistens er den blevet populær på sociale medier. Prøv Google Nano Banana gratis på 微鲤AI-billedgeneratoren nu!',
        
        // Core Features Section
        coreFeaturesTitle: 'Kernefunktioner i Nano Banana',
        coreFeaturesSubtitle: 'Udforsk kernefunktionerne i Google Nano Banana AI-billedgenerator og begynd en revolutionerende AI-billedskabelsesrejse',
        
        // Features
        soatTitle: 'SOAT-billedgenerering',
        soatDesc: 'Skab detaljerede billeder med uovertruffen stilpræcision. Nano Banana genererer billeder i professionel kvalitet og understøtter flere kunstneriske stilarter og kreative udtryk.',
        soatAlt: 'Eksempel på SOAT-billedgenerering',
        
        characterConsistencyTitle: 'Perfekt figurkonsistens',
        characterConsistencyDesc: 'Bevar figurer og sceneelementer ensartet på tværs af iterative ændringer. Udseende, træk og stil forbliver fuldstændig ens, uanset hvor mange billeder der genereres.',
        characterConsistencyAlt: 'Eksempel på perfekt figurkonsistens',
        
        naturalLanguageTitle: 'Billedredigering med naturligt sprog',
        naturalLanguageDesc: 'Avanceret billedredigering med almindelig tekst. Med simple beskrivelser kan du præcist justere detaljer, farver, stilarter og komposition.',
        naturalLanguageAlt: 'Eksempel på billedredigering med naturligt sprog',
        
        multiFusionTitle: 'Fusion af flere billeder',
        multiFusionDesc: 'Flet flere billeder, indsæt objekter, redesign scener eller kombiner visuelle effekter. Smart fusionsteknologi gør det let at skabe komplekse billedkompositioner.',
        multiFusionAlt: 'Eksempel på fusion af flere billeder',
        
        ultraFastTitle: 'Ultrahurtig billedbehandling',
        ultraFastDesc: 'Generér professionelle billeder på få sekunder. Nano Bananas optimerede algoritmer giver høj kvalitet hurtigt og forbedrer den kreative effektivitet markant.',
        ultraFastAlt: 'Eksempel på ultrahurtig billedbehandling',
        
        // How to Use Section
        howToUseTitle: 'Sådan bruger du',
        howToUseSubtitle: 'Tre enkle trin til at komme i gang',
        
        step1Title: 'Vælg model',
        step1Desc: 'Vælg Nano Banana-modellen i AI-billedværktøjerne',
        
        step2Title: 'Indtast indhold',
        step2Desc: 'Skriv prompts eller upload referencebilleder',
        
        step3Title: 'Generér billeder',
        step3Desc: 'Klik på generer-knappen, vent og download dine billeder',
        
        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om Nano Banana AI-billedmodel',
        
        // X Posts Section
        xPostsTitle: 'X-opslag om Nano Banana AI-billedmodel',
        
        // Explore Other Models Section
        exploreTitle: 'Udforsk andre AI-billedmodeller på 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'Ofte stillede spørgsmål',
        
        faq1Question: 'Hvad er Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) er en kraftfuld AI-billedgenerator, der lader brugere skabe og redigere billeder i høj kvalitet med enkelt sprog. Dens kernefordel er at håndtere komplekse instruktioner og sikre, at figurer og scener forbliver konsistente gennem flere redigeringer.',
        
        faq2Question: 'Hvilke fordele har Nano Banana i forhold til andre billedmodeller?',
        faq2Answer: 'Nano Banana har klare fordele inden for figurkonsistens, billedforfinelse, fusion af flere billeder og behandlingshastighed. Den bevarer figurens udseende på tværs af forskellige scener og understøtter billedredigering med naturligt sprog.',
        
        faq3Question: 'Kan jeg bruge Google Nano Banana gratis?',
        faq3Answer: 'Ja. Du kan bruge Nano Banana gratis til billedgenerering via 微鲤AI. Opret blot en konto, så kan du med vores gratis prøveplan opleve modellens fulde muligheder og hurtigt skabe AI-billeder i professionel kvalitet.',
        
        faq4Question: 'Hvilke billedformater understøtter Nano Banana?',
        faq4Answer: 'Nano Banana understøtter forskellige billedformater, herunder JPG, PNG, WEBP og andre almindelige formater. De genererede billeder har høj kvalitet og rige detaljer.',
        
        faq5Question: 'Kan jeg bruge Nano Banana til kommercielle projekter?',
        faq5Answer: 'Ja. Nano Bananas højpræcise billedgenerering og perfekte figurkonsistens gør den til et stærkt valg for designere, kunstnere og content creators, der ønsker AI-genererede billeder i høj kvalitet.',
        
        faq6Question: 'Hvilke kunstneriske stilarter understøtter Google Nano Banana?',
        faq6Answer: 'Du kan bruge Google Nano Banana til at generere billeder i enhver visuel stil. Uanset om det er realistisk, anime, abstrakt kunst, 3D-billeder eller fantasy, kan den klare det let, hvilket gør den ideel til digitale skabere som kunstnere, marketingfolk og spildesignere.',
        
        // CTA Section
        ctaTitle: 'Klar til at komme i gang?',
        ctaDescription: 'Prøv Google Nano Banana nu og gør dine idéer til fantastiske billeder',
        ctaButton: 'Prøv Nano Banana på 微鲤AI',
        ctaDisclaimer: 'Intet kreditkort kræves',
        },
    no: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI-bildegenerator – gratis bilder med karakterkonsistens',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) er en AI-modell for bildegenerering og redigering utviklet av Google DeepMind. Den er kjent for fremragende karakterkonsistens og har blitt populær på sosiale medier. Prøv Google Nano Banana gratis på 微鲤AI-bildegeneratoren!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, bildegenerering, AI-kunst, karakterkonsistens, bilderedigering, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI-bildegenerator',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) er en AI-modell for bildegenerering og redigering utviklet av Google DeepMind. Kjent for sin fremragende karakterkonsistens har den blitt populær på sosiale medier. Prøv Google Nano Banana gratis på 微鲤AI-bildegeneratoren nå!',
        
        // Core Features Section
        coreFeaturesTitle: 'Kjernefunksjoner i Nano Banana',
        coreFeaturesSubtitle: 'Utforsk kjernefunksjonene i Google Nano Banana AI-bildegenerator og start en revolusjonerende reise i AI-bildekreasjon',
        
        // Features
        soatTitle: 'SOAT-bildegenerering',
        soatDesc: 'Skap detaljerte bilder med enestående stilpresisjon. Nano Banana genererer bilder i profesjonell kvalitet og støtter flere kunstneriske stiler og kreative uttrykk.',
        soatAlt: 'Eksempel på SOAT-bildegenerering',
        
        characterConsistencyTitle: 'Perfekt karakterkonsistens',
        characterConsistencyDesc: 'Behold karakter- og sceneelementer konsistente gjennom iterative endringer. Utseende, trekk og stil forblir helt samstemte uansett hvor mange bilder som genereres.',
        characterConsistencyAlt: 'Eksempel på perfekt karakterkonsistens',
        
        naturalLanguageTitle: 'Bilderedigering med naturlig språk',
        naturalLanguageDesc: 'Avansert bilderedigering med vanlig tekst. Med enkle beskrivelser kan du presist justere detaljer, farger, stiler og komposisjon.',
        naturalLanguageAlt: 'Eksempel på bilderedigering med naturlig språk',
        
        multiFusionTitle: 'Fletting av flere bilder',
        multiFusionDesc: 'Slå sammen flere bilder, sett inn objekter, redesign scener eller kombiner visuelle effekter. Smart fusjonsteknologi gjør det enkelt å skape komplekse bildekomposisjoner.',
        multiFusionAlt: 'Eksempel på fletting av flere bilder',
        
        ultraFastTitle: 'Ultrarask bildebehandling',
        ultraFastDesc: 'Generer profesjonelle bilder på sekunder. Nano Bananas optimaliserte algoritmer gir høy kvalitet raskt og øker kreativ effektivitet betydelig.',
        ultraFastAlt: 'Eksempel på ultrarask bildebehandling',
        
        // How to Use Section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle steg for å komme i gang',
        
        step1Title: 'Velg modell',
        step1Desc: 'Velg Nano Banana-modellen i AI-bildeverktøyene',
        
        step2Title: 'Skriv inn innhold',
        step2Desc: 'Skriv inn prompts eller last opp referansebilder',
        
        step3Title: 'Generer bilder',
        step3Desc: 'Klikk på generer-knappen, vent og last ned bildene dine',
        
        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om Nano Banana AI-bildemodell',
        
        // X Posts Section
        xPostsTitle: 'X-innlegg om Nano Banana AI-bildemodell',
        
        // Explore Other Models Section
        exploreTitle: 'Utforsk andre AI-bildemodeller på 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'Ofte stilte spørsmål',
        
        faq1Question: 'Hva er Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) er en kraftig AI-bildegenerator som lar brukere lage og redigere bilder i høy kvalitet med enkel tekst. Kjernefordelen er å håndtere komplekse instruksjoner og sikre at karakterer og scener forblir konsistente gjennom flere redigeringer.',
        
        faq2Question: 'Hvilke fordeler har Nano Banana sammenlignet med andre bildemodeller?',
        faq2Answer: 'Nano Banana har store fordeler innen karakterkonsistens, bildefinjustering, flerbilde-fusjon og prosesseringshastighet. Den holder karakterens utseende konsistent på tvers av ulike scener og støtter bilderedigering med naturlig språk.',
        
        faq3Question: 'Kan jeg bruke Google Nano Banana gratis?',
        faq3Answer: 'Ja. Du kan bruke Nano Banana gratis til bildegenerering via 微鲤AI. Registrer en konto, og gratis prøveplan gir deg full tilgang til modellens evner for raskt å lage AI-bilder i profesjonell kvalitet.',
        
        faq4Question: 'Hvilke bildeformater støtter Nano Banana?',
        faq4Answer: 'Nano Banana støtter flere bildeformater, inkludert JPG, PNG, WEBP og andre vanlige formater. Genererte bilder har høy kvalitet og rike detaljer.',
        
        faq5Question: 'Kan jeg bruke Nano Banana til kommersielle prosjekter?',
        faq5Answer: 'Ja. Nano Bananas presise bildegenerering og perfekte karakterkonsistens gjør den til et sterkt valg for designere, kunstnere og innholdsskapere som ønsker AI-bilder av høy kvalitet.',
        
        faq6Question: 'Hvilke kunststiler støtter Google Nano Banana?',
        faq6Answer: 'Du kan bruke Google Nano Banana til å generere bilder i hvilken som helst visuell stil. Enten det er realistisk, anime, abstrakt kunst, 3D-bilder eller fantasy, håndterer den det enkelt – perfekt for digitale skapere som kunstnere, markedsførere og spilldesignere.',
        
        // CTA Section
        ctaTitle: 'Klar til å skape?',
        ctaDescription: 'Prøv Google Nano Banana nå og gjør ideene dine til fantastiske bilder',
        ctaButton: 'Prøv Nano Banana på 微鲤AI',
        ctaDisclaimer: 'Ingen kredittkort kreves',
        },
    nl: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI‑beeldgenerator - gratis beelden met karakterconsistentie',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) is een AI‑model voor beeldgeneratie en -bewerking van Google DeepMind. Bekend om uitstekende karakterconsistentie en populair op social media. Probeer Google Nano Banana gratis op de 微鲤AI‑beeldgenerator!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, beeldgeneratie, AI‑kunst, karakterconsistentie, beeldbewerking, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI‑beeldgenerator',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) is een AI‑model voor beeldgeneratie en -bewerking van Google DeepMind. Bekend om zijn uitstekende karakterconsistentie en populair op social media. Probeer Google Nano Banana nu gratis op de 微鲤AI‑beeldgenerator!',
        
        // Core Features Section
        coreFeaturesTitle: 'Kernfuncties van Nano Banana',
        coreFeaturesSubtitle: 'Ontdek de kernfuncties van Google Nano Banana AI‑beeldgenerator en begin aan een revolutionaire AI‑beeldcreatiereis',
        
        // Features
        soatTitle: 'SOAT‑beeldgeneratie',
        soatDesc: 'Maak gedetailleerde beelden met ongeëvenaarde stijlprecisie. Nano Banana genereert beelden van professionele kwaliteit en ondersteunt meerdere artistieke stijlen en creatieve expressies.',
        soatAlt: 'Voorbeeld van SOAT‑beeldgeneratie',
        
        characterConsistencyTitle: 'Perfecte karakterconsistentie',
        characterConsistencyDesc: 'Behoud karakter‑ en scène‑elementen consistent bij iteratieve wijzigingen. Uiterlijk, kenmerken en stijl blijven volledig uniform, hoeveel beelden je ook genereert.',
        characterConsistencyAlt: 'Voorbeeld van perfecte karakterconsistentie',
        
        naturalLanguageTitle: 'Beeldbewerking met natuurlijke taal',
        naturalLanguageDesc: 'Bereik geavanceerde beeldbewerking met gewone tekst. Met eenvoudige omschrijvingen kun je details, kleuren, stijlen en compositie precies aanpassen.',
        naturalLanguageAlt: 'Voorbeeld van beeldbewerking met natuurlijke taal',
        
        multiFusionTitle: 'Multi‑beeld‑fusie',
        multiFusionDesc: 'Voeg meerdere beelden samen, voeg objecten in, herontwerp scènes of combineer visuele effecten. Slimme fusietechnologie maakt complexe beeldcomposities eenvoudig.',
        multiFusionAlt: 'Voorbeeld van multi‑beeld‑fusie',
        
        ultraFastTitle: 'Ultrasnelle beeldverwerking',
        ultraFastDesc: 'Genereer beelden van professionele kwaliteit in enkele seconden. Nano Banana’s geoptimaliseerde algoritmen leveren snel resultaat van hoge kwaliteit en verhogen de creatieve efficiëntie aanzienlijk.',
        ultraFastAlt: 'Voorbeeld van ultrasnelle beeldverwerking',
        
        // How to Use Section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Drie eenvoudige stappen om te starten',
        
        step1Title: 'Selecteer model',
        step1Desc: 'Kies het Nano Banana‑model in de AI‑beeldtools',
        
        step2Title: 'Voer content in',
        step2Desc: 'Voer prompts in of upload referentiebeelden',
        
        step3Title: 'Genereer beelden',
        step3Desc: 'Klik op de knop genereren, wacht en download je beelden',
        
        // YouTube Videos Section
        youtubeTitle: 'YouTube‑video’s over het Nano Banana AI‑beeldmodel',
        
        // X Posts Section
        xPostsTitle: 'X‑posts over het Nano Banana AI‑beeldmodel',
        
        // Explore Other Models Section
        exploreTitle: 'Ontdek andere AI‑beeldmodellen op 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'Veelgestelde vragen',
        
        faq1Question: 'Wat is Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) is een krachtige AI‑beeldgenerator waarmee gebruikers hoogwaardige beelden kunnen maken en bewerken via eenvoudige taal. Het belangrijkste voordeel is het verwerken van complexe instructies en het behouden van karakter‑ en scèneconsistentie bij meerdere bewerkingen.',
        
        faq2Question: 'Welke voordelen heeft Nano Banana ten opzichte van andere beeldmodellen?',
        faq2Answer: 'Nano Banana blinkt uit in karakterconsistentie, beeldverfijning, multi‑beeld‑fusie en verwerkingssnelheid. Het houdt het uiterlijk van personages consistent in verschillende scènes en ondersteunt beeldbewerking met natuurlijke taal.',
        
        faq3Question: 'Kan ik Google Nano Banana gratis gebruiken?',
        faq3Answer: 'Ja. Je kunt Nano Banana gratis gebruiken voor beeldgeneratie via 微鲤AI. Registreer eenvoudig een account en ons gratis proefplan laat je de volledige mogelijkheden van het model ervaren om snel professionele AI‑beelden te maken.',
        
        faq4Question: 'Welke beeldformaten ondersteunt Nano Banana?',
        faq4Answer: 'Nano Banana ondersteunt verschillende beeldformaten, waaronder JPG, PNG, WEBP en andere gangbare formaten. De gegenereerde beelden zijn van hoge kwaliteit met rijke details.',
        
        faq5Question: 'Kan ik Nano Banana gebruiken voor commerciële projecten?',
        faq5Answer: 'Ja. De hoge precisie en perfecte karakterconsistentie van Nano Banana maken het een sterke keuze voor ontwerpers, kunstenaars en content creators die AI‑beelden van hoge kwaliteit zoeken.',
        
        faq6Question: 'Welke artistieke stijlen ondersteunt Google Nano Banana?',
        faq6Answer: 'Je kunt met Google Nano Banana beelden genereren in elke visuele stijl. Of het nu realistisch, anime, abstracte kunst, 3D‑beelden of fantasy is, het model kan het moeiteloos aan — ideaal voor digitale creators zoals kunstenaars, marketeers en game‑designers.',
        
        // CTA Section
        ctaTitle: 'Klaar om te starten?',
        ctaDescription: 'Probeer Google Nano Banana nu en zet je ideeën om in geweldige beelden',
        ctaButton: 'Probeer Nano Banana op 微鲤AI',
        ctaDisclaimer: 'Geen creditcard nodig',
        },
    id: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI Image Generator - Gambar Konsisten Karakter Gratis',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image) adalah model AI untuk pembuatan dan pengeditan gambar dari Google DeepMind. Dikenal karena konsistensi karakter yang luar biasa dan populer di media sosial. Coba Google Nano Banana gratis di 微鲤AI image generator!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, pembuatan gambar, seni AI, konsistensi karakter, pengeditan gambar, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Generator Gambar AI Google Nano Banana',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image) adalah model AI untuk pembuatan dan pengeditan gambar dari Google DeepMind. Dikenal karena konsistensi karakter yang luar biasa dan populer di media sosial. Coba Google Nano Banana gratis di 微鲤AI image generator sekarang!',
        
        // Core Features Section
        coreFeaturesTitle: 'Fitur inti Nano Banana',
        coreFeaturesSubtitle: 'Jelajahi fitur inti Google Nano Banana AI Image Generator dan mulai perjalanan kreasi gambar AI yang revolusioner',
        
        // Features
        soatTitle: 'Generasi Gambar SOAT',
        soatDesc: 'Buat gambar detail dengan presisi gaya yang tak tertandingi. Nano Banana menghasilkan gambar berkualitas profesional dan mendukung banyak gaya artistik serta ekspresi kreatif.',
        soatAlt: 'Contoh Generasi Gambar SOAT',
        
        characterConsistencyTitle: 'Konsistensi karakter sempurna',
        characterConsistencyDesc: 'Pertahankan elemen karakter dan adegan secara konsisten sepanjang perubahan berulang. Penampilan, fitur, dan gaya karakter tetap seragam berapa pun jumlah gambar yang dihasilkan.',
        characterConsistencyAlt: 'Contoh Konsistensi Karakter Sempurna',
        
        naturalLanguageTitle: 'Pengeditan gambar dengan bahasa alami',
        naturalLanguageDesc: 'Lakukan pengeditan gambar tingkat lanjut menggunakan teks biasa. Dengan deskripsi sederhana, Anda bisa menyesuaikan detail, warna, gaya, dan komposisi secara presisi.',
        naturalLanguageAlt: 'Contoh Pengeditan Gambar dengan Bahasa Alami',
        
        multiFusionTitle: 'Fusi multi-gambar',
        multiFusionDesc: 'Gabungkan beberapa gambar, sisipkan objek, desain ulang adegan, atau kombinasikan efek visual. Teknologi fusi cerdas membuat komposisi kompleks jadi mudah.',
        multiFusionAlt: 'Contoh Fusi Multi-Gambar',
        
        ultraFastTitle: 'Pemrosesan gambar ultra cepat',
        ultraFastDesc: 'Hasilkan gambar berkualitas profesional dalam hitungan detik. Algoritme Nano Banana yang dioptimalkan memastikan hasil berkualitas tinggi dengan cepat, meningkatkan efisiensi kreatif.',
        ultraFastAlt: 'Contoh Pemrosesan Gambar Ultra Cepat',
        
        // How to Use Section
        howToUseTitle: 'Cara menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk memulai',
        
        step1Title: 'Pilih model',
        step1Desc: 'Pilih model Nano Banana di alat gambar AI',
        
        step2Title: 'Masukkan konten',
        step2Desc: 'Masukkan prompt atau unggah gambar referensi',
        
        step3Title: 'Hasilkan gambar',
        step3Desc: 'Klik tombol generate, tunggu dan unduh gambar Anda',
        
        // YouTube Videos Section
        youtubeTitle: 'Video YouTube tentang model gambar AI Nano Banana',
        
        // X Posts Section
        xPostsTitle: 'Posting X tentang model gambar AI Nano Banana',
        
        // Explore Other Models Section
        exploreTitle: 'Jelajahi model gambar AI lainnya di 微鲤AI',
        imagenTitle: 'Google Imagen AI Image Generator',
        qwenTitle: 'Qwen Image AI Image Generator',
        seedreamTitle: 'Seedream AI Image Generator',
        
        // FAQ Section
        faqTitle: 'Pertanyaan yang sering diajukan',
        
        faq1Question: 'Apa itu Google Nano Banana?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image) adalah generator gambar AI yang kuat yang memungkinkan pengguna membuat dan mengedit gambar berkualitas tinggi dengan bahasa sederhana. Keunggulannya adalah mampu menangani instruksi kompleks serta menjaga konsistensi karakter dan adegan di berbagai edit.',
        
        faq2Question: 'Apa keunggulan Nano Banana dibanding model generasi gambar lainnya?',
        faq2Answer: 'Nano Banana unggul dalam konsistensi karakter, penyempurnaan gambar, fusi multi-gambar, dan kecepatan pemrosesan. Ia menjaga konsistensi tampilan karakter di berbagai adegan dan mendukung pengeditan gambar dengan bahasa alami.',
        
        faq3Question: 'Apakah saya bisa memakai Google Nano Banana gratis?',
        faq3Answer: 'Ya. Anda bisa menggunakan Nano Banana gratis untuk pembuatan gambar lewat 微鲤AI. Cukup daftar akun, dan paket uji coba gratis memungkinkan Anda merasakan kemampuan penuh model ini untuk membuat gambar AI berkualitas profesional dengan cepat.',
        
        faq4Question: 'Format gambar apa yang didukung Nano Banana?',
        faq4Answer: 'Nano Banana mendukung berbagai format gambar termasuk JPG, PNG, WEBP, dan format umum lainnya. Gambar yang dihasilkan berkualitas tinggi dengan detail yang kaya.',
        
        faq5Question: 'Apakah Nano Banana bisa digunakan untuk proyek komersial?',
        faq5Answer: 'Ya. Generasi gambar presisi tinggi dan konsistensi karakter yang sempurna membuat Nano Banana menjadi pilihan kuat bagi desainer, seniman, dan kreator konten yang membutuhkan gambar AI berkualitas tinggi.',
        
        faq6Question: 'Gaya artistik apa yang didukung Google Nano Banana?',
        faq6Answer: 'Anda dapat menggunakan Google Nano Banana untuk membuat gambar dalam gaya visual apa pun. Baik realistis, anime, seni abstrak, gambar 3D, atau fantasi, semuanya bisa ditangani dengan mudah — ideal untuk kreator digital seperti seniman, pemasar, dan desainer game.',
        
        // CTA Section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription: 'Coba Google Nano Banana sekarang dan ubah ide Anda menjadi gambar yang menakjubkan',
        ctaButton: 'Coba Nano Banana di 微鲤AI',
        ctaDisclaimer: 'Tidak perlu kartu kredit',
        },
    tr: {
        // SEO Meta
        metaTitle: 'Google Nano Banana AI Görsel Üretici - Ücretsiz Karakter Tutarlı Görseller',
        metaDescription: 'Google Nano Banana (Gemini 2.5 Flash Image), Google DeepMind tarafından geliştirilen bir AI görsel üretim ve düzenleme modelidir. Üstün karakter tutarlılığıyla bilinir ve sosyal medyada popüler olmuştur. 微鲤AI’de Google Nano Banana’yı ücretsiz deneyin!',
        metaKeywords: 'Nano Banana, Gemini 2.5, Google AI, görsel üretimi, AI sanat, karakter tutarlılığı, görsel düzenleme, Google DeepMind',
        
        // Generator Section
        generatorTitle: 'Google Nano Banana AI Görsel Üretici',
        generatorSubtitle: 'Google Nano Banana (Gemini 2.5 Flash Image), Google DeepMind tarafından geliştirilen bir AI görsel üretim ve düzenleme modelidir. Üstün karakter tutarlılığıyla bilinir ve sosyal medyada popüler olmuştur. 微鲤AI görsel üreticide Google Nano Banana’yı şimdi ücretsiz deneyin!',
        
        // Core Features Section
        coreFeaturesTitle: 'Nano Banana’nın Temel Özellikleri',
        coreFeaturesSubtitle: 'Google Nano Banana AI Görsel Üreticinin temel özelliklerini keşfedin ve devrimsel bir AI görsel oluşturma yolculuğuna çıkın',
        
        // Features
        soatTitle: 'SOAT Görsel Üretimi',
        soatDesc: 'Eşi benzeri olmayan stil hassasiyetiyle detaylı görseller oluşturun. Nano Banana, birçok sanatsal stil ve yaratıcı ifadeyi destekleyen profesyonel kalitede görseller üretir.',
        soatAlt: 'SOAT Görsel Üretimi Örneği',
        
        characterConsistencyTitle: 'Mükemmel Karakter Tutarlılığı',
        characterConsistencyDesc: 'Yinelemeli değişikliklerde karakter ve sahne öğelerini tutarlı tutar. Kaç görsel üretilirse üretilsin karakter görünümü, özellikleri ve stili mükemmel şekilde korunur.',
        characterConsistencyAlt: 'Mükemmel Karakter Tutarlılığı Örneği',
        
        naturalLanguageTitle: 'Doğal Dil ile Görsel Düzenleme',
        naturalLanguageDesc: 'Sade metinle gelişmiş görsel düzenleme yapın. Basit açıklamalarla detayları, renkleri, stilleri ve kompozisyonu hassas biçimde ayarlayın.',
        naturalLanguageAlt: 'Doğal Dil ile Görsel Düzenleme Örneği',
        
        multiFusionTitle: 'Çoklu Görsel Füzyonu',
        multiFusionDesc: 'Birden fazla görseli birleştirin, nesneler ekleyin, sahneleri yeniden tasarlayın veya görsel efektleri birleştirin. Akıllı füzyon teknolojisiyle karmaşık kompozisyonları kolayca oluşturun.',
        multiFusionAlt: 'Çoklu Görsel Füzyonu Örneği',
        
        ultraFastTitle: 'Ultra Hızlı Görsel İşleme',
        ultraFastDesc: 'Saniyeler içinde profesyonel kalitede görseller üretin. Nano Banana’nın optimize algoritmaları, hızlı ve yüksek kaliteli sonuçlar sunarak yaratıcı verimliliği artırır.',
        ultraFastAlt: 'Ultra Hızlı Görsel İşleme Örneği',
        
        // How to Use Section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Başlamak için üç basit adım',
        
        step1Title: 'Model Seçin',
        step1Desc: 'AI görsel araçlarında Nano Banana modelini seçin',
        
        step2Title: 'İçerik Girin',
        step2Desc: 'Prompt girin veya referans görseller yükleyin',
        
        step3Title: 'Görselleri Üretin',
        step3Desc: 'Oluştur düğmesine tıklayın, bekleyin ve görsellerinizi indirin',
        
        // YouTube Videos Section
        youtubeTitle: 'Nano Banana AI Görsel Modeli Hakkında YouTube Videoları',
        
        // X Posts Section
        xPostsTitle: 'Nano Banana AI Görsel Modeli Hakkında X Paylaşımları',
        
        // Explore Other Models Section
        exploreTitle: '微鲤AI’de Diğer AI Görsel Modellerini Keşfedin',
        imagenTitle: 'Google Imagen AI Görsel Üretici',
        qwenTitle: 'Qwen Image AI Görsel Üretici',
        seedreamTitle: 'Seedream AI Görsel Üretici',
        
        // FAQ Section
        faqTitle: 'Sıkça Sorulan Sorular',
        
        faq1Question: 'Google Nano Banana nedir?',
        faq1Answer: 'Google Nano Banana (Gemini 2.5 Flash Image), basit bir dille yüksek kaliteli görseller oluşturmanıza ve düzenlemenize olanak tanıyan güçlü bir AI görsel üreticisidir. Temel avantajı, karmaşık talimatları yönetmesi ve karakter ile sahneleri birden fazla düzenlemede tutarlı tutmasıdır.',
        
        faq2Question: 'Nano Banana’nın diğer görsel üretim modellerine göre avantajları nelerdir?',
        faq2Answer: 'Nano Banana; karakter tutarlılığı, görsel iyileştirme, çoklu görsel füzyonu ve işlem hızında büyük avantajlara sahiptir. Farklı sahnelerde karakter görünümünü tutarlı tutar ve doğal dil ile görsel düzenlemeyi destekler.',
        
        faq3Question: 'Google Nano Banana’yı ücretsiz kullanabilir miyim?',
        faq3Answer: 'Evet. Nano Banana’yı 微鲤AI üzerinden ücretsiz görsel üretimi için kullanabilirsiniz. Sadece hesap oluşturun; ücretsiz deneme planı, profesyonel kalitede AI görsellerini hızlıca üretmek için tüm yetenekleri deneyimlemenizi sağlar.',
        
        faq4Question: 'Nano Banana hangi görsel formatlarını destekler?',
        faq4Answer: 'Nano Banana; JPG, PNG, WEBP ve diğer yaygın formatları destekler. Üretilen görseller yüksek kalite ve zengin detay sunar.',
        
        faq5Question: 'Nano Banana’yı ticari projelerde kullanabilir miyim?',
        faq5Answer: 'Evet. Nano Banana’nın yüksek hassasiyetli görsel üretimi ve mükemmel karakter tutarlılığı, yüksek kaliteli AI görselleri arayan tasarımcılar, sanatçılar ve içerik üreticileri için güçlü bir tercihtir.',
        
        faq6Question: 'Google Nano Banana hangi sanatsal stilleri destekler?',
        faq6Answer: 'Google Nano Banana ile her türlü görsel stilde üretim yapabilirsiniz. Gerçekçi, anime, soyut sanat, 3D görseller veya fantezi sanatı gibi stilleri kolayca işler; sanatçılar, pazarlamacılar ve oyun tasarımcıları gibi dijital üreticiler için idealdir.',
        
        // CTA Section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription: 'Google Nano Banana’yı şimdi deneyin ve fikirlerinizi harika görsellere dönüştürün',
        ctaButton: '微鲤AI’de Nano Banana’yı deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',
    },
}
